<template>
	<basic-container class="content_top">
		<el-steps :active="currentStep * 1" align-center finish-status="success" show-icon>
			<el-step title="保单录入"></el-step>
			<el-step title="信息确认"></el-step>
			<el-step title="保单支付"></el-step>
			<el-step title="完成投保"></el-step>
		</el-steps>

		<el-row justify="center" style="margin-top: 15px; height: 55px" type="flex">
			<h2>{{ productName }}</h2>
		</el-row>
		<el-tabs v-model="currentStep" tab-position="top">
			<el-tab-pane label="" name="0">
				<el-card v-if="!isEndorsement">
					<div slot="header">
						<span>{{ onGetTitleContent[0] }}</span>
						<el-tooltip
							:content="onGetTitleContent[2]"
							:disabled="!product.holder.holderOnly"
							effect="light"
							placement="top">
							<el-checkbox
								v-model="formSubmit.sameUnit"
								:disabled="product.holder.holderOnly"
								style="float: right; padding: 4px 0"
								@change="handleSameUnitChanged">
								{{ onGetTitleContent[1] }}
							</el-checkbox>
						</el-tooltip>
					</div>
					<el-alert
						v-if="product.holder.showSelfEmployed"
						:title="unitHint"
						show-icon
						style="margin-bottom: 10px"
						type="warning"></el-alert>
					<unit-form
						ref="holder"
						:insureTypeTemp="product.type"
						:my-insure-confirm="myInsureConfirm"
						:priceHintData="{totalPrice, isEmployeeSubmitted: formEmployee.isSubmitted}"
						:productId="product.id"
						:showCategory="product.holder.showCategory"
						:showIndustry="product.holder.showIndustry"
						:unitType="formSubmit.sameUnit ? '0' : '1'"
						@onChangeInure="onChangeInure"
						@onChangeProductId="onChangeProductId"
						@onGoToTop="onGoToTop"
						@onSubmitted="onHolderSubmitted"
						@onUnsubmitted="formSubmit.isHolderSubmitted = false"></unit-form>
				</el-card>
				<el-card v-if="!isEndorsement && !formSubmit.sameUnit" header="被保企业（上传营业执照可自动识别企业信息）">
					<unit-form
						ref="insured"
						:insureTypeTemp="product.type"
						:productId="product.id"
						:showCategory="product.holder.showCategory"
						:showIndustry="product.holder.showIndustry"
						unitType="2"
						@onChangeInure="onChangeInure"
						@onChangeProductId="onChangeProductId"
						@onSubmitted="onInsuredSubmitted"
						@onUnsubmitted="formSubmit.isInsuredSubmitted = false"></unit-form>
				</el-card>

				<!--盖章文件-->
				<file-confirm
					v-if="!isEndorsement"
					ref="refFiles"
					:insureType="product.type"
					:productId="product.id"
					@onChangeProductId="onChangeProductId"></file-confirm>

				<unit-insured-form
					v-if="product.isShowInsuredList"
					ref="unitInsured"
					:holder-code="formSubmit.toubao.unit_code"
					:productId="product.id"
					style="margin-bottom: 20px"></unit-insured-form>

				<el-card header="投保方案">
					<el-row :gutter="20">
						<el-col :span="12">
							<div>方案选择</div>
							<plan-form
								ref="plan"
								:coverageNotice="product.plan.coverageNotice"
								:insureType="product.type"
								:planCoverage="planCoverage"
								:productCode="productCode"
								:productId="product.id"
								:readOnly="isEndorsement"
								@categoryFiltered="onCategoryFiltered"
								@insureSuddenDeath="onInsureSuddenDeath"
								@levelChange="onProfessionLevelChange"
								@onPlanChangeAddMaim="onPlanChangeAddMaim"
								@onSubmitted="onPlanSubmitted"
								@onUnsubmitted="formSubmit.isPlanSubmitted = false"
								@planChange="onPlanChanged"></plan-form>
						</el-col>
						<el-col v-if="!isEndorsement" :span="12">
							<div>生效时间</div>
							<period-form
								ref="period"
								:maxEffectiveDate="maxEffectiveDate"
								:minEffectiveDate="minEffectiveDate"
								:periodListTemp="product.period.periodList"
								@onSubmitted="onPeriodSubmitted"
								@onUnsubmitted="formSubmit.isPeriodSubmitted = false"
								@periodChange="onPeriodChanged"></period-form>
						</el-col>
						<el-col v-else :span="12">
							<div>生效时间</div>
							<period-endorse-form
								ref="periodEndorse"
								:basePrice="endorseBasePrice"
								:insureType="product.type"
								:maxEffectiveDate="maxEffectiveDate"
								:minEffectiveDate="minEffectiveDate"
								:shortRatesList="shortRatesList"
								@onSubmitted="onPeriodSubmitted"
								@onUnsubmitted="formSubmit.isPeriodSubmitted = false"
								@periodChange="calcAllEmployeePremium"></period-endorse-form>
						</el-col>
					</el-row>
				</el-card>
				<!-- 阳光车意险-->
				<car-form
					v-if="product.isInsureCar"
					ref="carForm"
					:formSubmit="formSubmit"
					:tableLoading="employeeLoading"
					@onSubmitCarData="onSubmitCarData"></car-form>

				<el-card v-if="isInitOver && !product.isInsureCar" header="投保人员">
					<div slot="header">
						<span>被保险人</span>
					</div>
					<template>
						<el-row>
							<avue-crud
								ref="crud"
								:data="dataEmployee"
								:option="optionEmployee"
								:page.sync="page"
								:table-loading="employeeLoading"
								@cell-mouse-leave="employeeCellMouseLeave">
								<template v-if="!product.employee.maxEmployeeCount" slot="menuRight">
									<el-upload
										ref="upload"
										:auto-upload="false"
										:on-change="handleEmployeeFileChange"
										:show-file-list="false"
										accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
										action=""
										style="display: inline-block; float: right">
										<el-button class="el-icon-upload2" type="primary">批量上传</el-button>
									</el-upload>
									<el-button :loading="isDownLoading" @click="handleGetEmployeeTemplate">模板</el-button>
								</template>
								<template slot="profession" slot-scope="scope">
									<el-cascader
										v-model="scope.row.profession"
										:disabled="formEmployee.isSubmitted"
										:filterable="true"
										:options="optionsProfession"
										:props="{value: 'categoryCode', label: 'categoryName'}"
										:show-all-levels="false"
										placeholder="请选择 职业"
										@change="handleProfessionChange(scope.row)"></el-cascader>
								</template>
								<template slot="feeRate" slot-scope="scope">
									<el-select
										v-model="scope.row.feeRate"
										:disabled="formEmployee.isSubmitted || scope.row.feeRateDisabled"
										placeholder="请选择是否涉高"
										@change="onFeeRateChange(scope.row)">
										<el-option
											v-for="item in feeRateDicData"
											:key="item.value"
											:label="item.label"
											:value="item.value"></el-option>
									</el-select>
								</template>
							</avue-crud>
						</el-row>
						<el-row justify="end" type="flex">
							<span>保费合计：{{ totalPrice }}元</span>
						</el-row>
						<el-row justify="center" type="flex">
							<el-button
								v-if="!formEmployee.isSubmitted"
								:loading="formEmployee.isLoading"
								icon="el-icon-check"
								type="primary"
								@click="submitEmployee">
								确认
							</el-button>
							<el-button v-if="formEmployee.isSubmitted" icon="el-icon-edit" @click="handleEmployeeModify">
								修改
							</el-button>
						</el-row>
					</template>
				</el-card>

				<el-card v-if="isInitOver" header="开具发票">
					<invoice-form
						ref="invoice"
						:insureType="product.type"
						:supportSpecial="product.invoice.supportSpecialInvoice"
						@onSubmitted="onInvoiceSubmitted"
						@onUnsubmitted="formSubmit.isInvoiceSubmitted = false"></invoice-form>
				</el-card>

				<template v-if="!isEndorsement && isInitOver">
					<!--                    <div v-else>-->
					<!--                        <el-card header="投保须知">-->
					<!--                            <el-container style="height: 500px;">-->
					<!--                                <el-main>-->
					<!--                                    <el-alert type="error" :closable="false"><span-->
					<!--                                        style="font-size:1.25em; font-weight:bold">为保障您的合法权益，请您仔细阅读以下各部分内容，重要内容将以红色加粗字体为您标记，请务必知晓。如有疑问，请先联系客服人员确认无误后再行投保。</span>-->
					<!--                                    </el-alert>-->
					<!--                                    <insured-notice :productId="product.id" :insureType="product.type"></insured-notice>-->
					<!--                                    <el-card header="投保人声明">-->
					<!--                                        <el-alert type="error" :closable="false"><span style="font-size: 1.125em; font-weight: bold;">为保障您的合法权益，请您仔细阅读后勾选确认</span></el-alert>-->
					<!--                                        <el-row type="flex" justify="start">-->
					<!--                                            <div class="formView">-->
					<!--                                                <el-checkbox-group v-model="checkListStatement">-->
					<!--                                                    <el-checkbox-->
					<!--                                                        label="本投保人已完整阅读并了解投保须知内容及投保险种的保险条款内容，尤其是对其中免除保险人责任的条款或约定（包括但不限于责任免除、投保人被保险人义务、保险金申请与给付等），本投保人已充分理解并接受上述内容，同意以此作为订立保险合同的依据。"></el-checkbox>-->
					<!--                                                    <el-checkbox label="投保时，本投保人已就该产品的保障内容及保险金额等向被保险人进行了明确说明，并征得其同意。"></el-checkbox>-->
					<!--                                                </el-checkbox-group>-->
					<!--                                            </div>-->
					<!--                                        </el-row>-->
					<!--                                    </el-card>-->
					<!--                                </el-main>-->
					<!--                            </el-container>-->
					<!--                        </el-card>-->
					<!--                        <el-row type="flex" justify="center">-->
					<!--                            <el-tag type=""><span style="font-size: 1.125em; font-weight: bold;">请滑动鼠标至底部，阅读并确认全部内容</span></el-tag>-->
					<!--                            <p></p>-->
					<!--                        </el-row>-->
					<!--                        <el-row type="flex" justify="center">-->
					<!--                            <el-button @click="handleAddStaging">未填好，保存草稿</el-button>-->
					<!--                            <el-button type="primary" :disabled="!everythingConfirmed" @click="handleStepConfirm">我已逐条阅读并同意投保</el-button>-->
					<!--                        </el-row>-->
					<!--                    </div>-->

					<custom-notice
						ref="custom_notice"
						:insureType="product.type"
						:isShowPdf="product.isShowPdfInsured"
						:productId="product.id"
						@onInsureReadOver="onInsureReadOver"></custom-notice>

					<el-card v-if="isShowInsuredBtn" header="投保人声明">
						<el-alert :closable="false" type="error">
							<span style="font-size: 1.125em; font-weight: bold">为保障您的合法权益，请您仔细阅读后勾选确认</span>
						</el-alert>
						<el-row justify="start" type="flex">
							<div class="formView" style="margin-top: 10px">
								<el-checkbox-group v-model="checkListStatement">
									<el-checkbox
										label="本投保人已完整阅读并了解投保须知内容及投保险种的保险条款内容，尤其是对其中免除保险人责任的条款或约定（包括但不限于责任免除、投保人被保险人义务、保险金申请与给付等），本投保人已充分理解并接受上述内容，同意以此作为订立保险合同的依据。"></el-checkbox>
									<el-checkbox
										label="投保时，本投保人已就该产品的保障内容及保险金额等向被保险人进行了明确说明，并征得其同意。"></el-checkbox>
								</el-checkbox-group>
							</div>
						</el-row>
						<el-row justify="center" style="margin-top: 5px" type="flex">
							<el-tag type="">
								<span style="font-size: 1.125em; font-weight: bold">请滑动鼠标至底部，阅读并确认全部内容</span>
							</el-tag>
							<p></p>
						</el-row>
						<el-row justify="center" type="flex">
							<el-button v-if="!product.isShowPdfInsured" plain type="primary" @click="handleAddStaging">
								暂存保单
							</el-button>
							<el-button v-else plain type="primary" @click="onBackInsured">查看投保须知</el-button>
							<el-button :disabled="!everythingConfirmed" type="primary" @click="handleStepConfirm">
								我已逐条阅读并同意投保
							</el-button>
						</el-row>
					</el-card>
					<float-btn :loading="isAddStaging" text="暂存保单" @onFloatBtnClicked="handleAddStaging"></float-btn>
				</template>
				<template v-else>
					<el-row justify="center" type="flex">
						<el-button
							:disabled="!everythingConfirmed"
							:loading="isCheckingInsure"
							type="primary"
							@click="handleStepConfirm">
							同意投保>>
						</el-button>
					</el-row>
				</template>
			</el-tab-pane>
			<el-tab-pane label="" name="1">
				<template v-if="isInitOver">
					<el-row :gutter="20">
						<el-col>
							<el-card header="投保信息">
								<div slot="header">
									<span>投保信息</span>
									<span style="float: right; font-weight: bold">
										保费合计：
										<span style="font-weight: bold; font-size: 1.25em; color: red">{{ totalPrice }}</span>
										元
									</span>
								</div>

								<div v-if="product.isInsureCar">
									<avue-crud :data="formSubmit.vehs" :option="optionEmployeeView">
										<template slot="menuLeft">
											<div>
												{{ this.formSubmit.toubao.certType === '100' ? '联系人' : '企业名称' }}：
												<span style="font-weight: bold">{{ formSubmit.toubao.unit_name }}</span>
											</div>
											<div v-if="formSubmit.toubao.certType === '100'">
												身份证号：
												<span style="font-weight: bold">{{ formSubmit.toubao.unit_code }}</span>
											</div>
											<div>
												保障时间：自
												<span style="font-weight: bold; color: red; margin: 10px 0">
													{{ formSubmit.strEffectiveDate }}
												</span>
												起至
												<span style="font-weight: bold; color: red">{{ formSubmit.strExpiryDate }}</span>
												止
											</div>
										</template>
									</avue-crud>
								</div>

								<div v-else>
									<avue-crud ref="crudCheckInsure" :data="dataEmployee" :option="optionEmployeeView" :page.sync="page">
										<template slot="menuLeft">
											<div>
												企业名称：
												<span style="font-weight: bold">{{ formSubmit.toubao.unit_name }}</span>
											</div>
											<div>
												保障时间：自
												<span style="font-weight: bold; color: red; margin: 10px 0">
													{{ formSubmit.strEffectiveDate }}
												</span>
												起至
												<span style="font-weight: bold; color: red">{{ formSubmit.strExpiryDate }}</span>
												止
											</div>

											<div v-if="!isEndorsement">
												保障期限：
												<span class="red-bold">{{ formSubmit.term }}</span>
												个月
											</div>
											<div v-else>
												保障天数：
												<span class="red-bold">{{ formSubmit.term }}</span>
												天
											</div>
										</template>
										<template slot="profession" slot-scope="scope">
											<span>{{ getProfessionName(scope.row.profession) }}</span>
										</template>
										<template slot="coverage">
											<span>{{ formSubmit.coverage }}万</span>
										</template>
										<template slot="remark" slot-scope="scope">
											<span style="color: red; font-weight: bold">{{ scope.row.remark }}</span>
										</template>
									</avue-crud>
								</div>

								<invoice-view ref="invoiceView" :insureType="product.type" style="margin-top: 20px"></invoice-view>
							</el-card>
						</el-col>
					</el-row>
					<el-row justify="center" type="flex">
						<el-button @click="handleStepInsure">&lt;&lt;上一步，修改保单</el-button>
						<el-button :loading="isCheckingInsure" type="primary" @click="handleStepPay">下一步，去支付>></el-button>
					</el-row>
				</template>
			</el-tab-pane>
			<el-tab-pane label="" name="2">
				<template v-if="currentStep === '2'">
					<el-row :gutter="20" justify="center" type="flex">
						<el-col v-if="allowOnline" :span="12">
							<el-card header="在线支付" style="height: 450px">
								<el-row justify="start" style="margin-bottom: 10px" type="flex">
									<span>通过线上付款的方式支付保费：{{ totalPrice }}元</span>
								</el-row>
								<el-row justify="start" type="flex">
									<div class="formView">
										<el-checkbox v-model="payOnlineWarningChecked">
											我已知悉：选择该支付方式后，如果再通过其他支付方式转账给保险公司，保险公司无法生成电子保单，后果自负。如果重新选择线下对公转账，必须重新登录。
										</el-checkbox>
									</div>
								</el-row>
								<el-row justify="center" style="margin-top: 20px" type="flex">
									<el-button
										:disabled="!payOnlineWarningChecked"
										:loading="isPay"
										round
										size="medium"
										type="success"
										@click="onPayOnline">
										马上支付
									</el-button>
								</el-row>
							</el-card>
						</el-col>
						<el-col v-if="isShowOfflinePayFan && allowOffline" :span="12">
							<el-card header="对公打款" style="height: 450px">
								<div style="margin-bottom: 10px">对公转账须知：</div>
								<div style="margin-bottom: 10px">{{ formPayOffline.refusePrompt }}</div>
								<el-row justify="start" style="margin-bottom: 10px" type="flex">
									<div class="formView">
										<el-checkbox v-model="payOfflineWarning1Checked">我已知悉：{{ formPayOffline.remind }}</el-checkbox>

										<el-checkbox v-model="payOfflineWarning2Checked" style="margin-top: 5px">
											我已知悉：对公转账须以企业对公账户打款，且转账金额须与保单保费一致。如以个人账户打款，或金额不一致，保险公司无法确认收款，保单无法生效。
										</el-checkbox>
									</div>
								</el-row>
								<el-row justify="center" style="margin-top: 20px" type="flex">
									<el-button
										:disabled="!payOfflineWarning1Checked || !payOfflineWarning2Checked"
										:loading="isPay"
										round
										size="medium"
										type="success"
										@click="handlePayOffline">
										对公打款
									</el-button>
								</el-row>
							</el-card>
						</el-col>
					</el-row>
					<el-row justify="center" type="flex">
						<el-button :disabled="isPay" @click="handleStepConfirm">&lt;&lt;上一步，确认保单</el-button>
					</el-row>
				</template>
			</el-tab-pane>
			<el-tab-pane label="" name="3">
				<template v-if="currentStep === '3'">
					<el-row v-if="paySource == 1">
						<el-row justify="center" type="flex">
							<el-col :span="12">提交成功</el-col>
						</el-row>
						<el-row justify="center" type="flex">
							<el-col :span="12">正在获取保险公司系统的支付结果...</el-col>
						</el-row>
						<el-row justify="center" type="flex">
							<el-col :span="12">
								如果您还未完成支付，请
								<el-button :loading="isPay" type="primary" @click="onDealPay">继续支付</el-button>
							</el-col>
						</el-row>
						<el-row justify="center" type="flex">
							<el-col :span="12">
								如果您已完成支付，请
								<el-button type="success" @click="handleViewPolicy">查看保单详情</el-button>
							</el-col>
						</el-row>
					</el-row>
					<el-row v-if="paySource == 2">
						<el-row justify="center" type="flex">
							<el-col :span="12">
								<el-alert :title="formPayOffline.refusePrompt" type="warning"></el-alert>
							</el-col>
						</el-row>
						<el-row justify="center" type="flex">
							<el-col :span="12">
								<avue-form v-model="formPayOffline" :option="optionPayOffline" @submit="submitTransferCertificate">
									<template slot="accountName" slot-scope="scope">
										<span>{{ scope.value }}</span>
									</template>
									<template slot="accountOpening" slot-scope="scope">
										<span>{{ scope.value }}</span>
									</template>
									<template slot="account" slot-scope="scope">
										<span>{{ scope.value }}</span>
									</template>
									<template slot="certificate">
										<el-upload
											:auto-upload="false"
											:before-upload="beforeTransferCertificateUpload"
											:on-change="onTransferCertificateChange"
											:on-success="handleTransferCertificateSuccess"
											:show-file-list="false"
											action=""
											class="avatar-uploader">
											<img v-if="imageTransferCertificate" :src="imageTransferCertificate" class="avatar" />
											<i v-else class="el-icon-plus avatar-uploader-icon"></i>
										</el-upload>
									</template>
								</avue-form>
							</el-col>
						</el-row>
					</el-row>
				</template>
			</el-tab-pane>
		</el-tabs>

		<el-dialog :visible.sync="repeatEmpListDialogVisible" title="提示" width="60%">
			<avue-crud
				ref="crud"
				:data="repeatEmpList"
				:option="optionRepeatEmployee"
				:table-loading="tableLoadingRepeatEmpList">
				<template slot="menuLeft">
					当前被保企业：
					<span style="font-weight: bold">{{ formSubmit.beibao.unit_name }}</span>
					<el-alert title="以下投保人员已通过其他企业投保，请确认是否需要再次投保？" type="warning"></el-alert>
				</template>
			</avue-crud>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="repeatEmpListDialogVisible = false">修改投保人员</el-button>
				<el-button @click="handleConfirmInsure">确认再次投保</el-button>
			</span>
		</el-dialog>
		<repeat-emps-dlg ref="repeatEmpsDlg" @removeRepeatEmps="handleRemoveRepeatEmps"></repeat-emps-dlg>
		<repeat-car-dlg ref="repeatCarDlg"></repeat-car-dlg>

		<payer-info ref="payerInfo" @onPayerInfo="onPayerInfo"></payer-info>

		<el-dialog
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			:top="'25vh'"
			:visible.sync="maintenanceFlag"
			title="操作须知"
			width="30%">
			<div>
				如何替换、加人，您知道了吗？
				<br />
				如何制作精美的投保计划书，您知道吗？
				<br />
				职业、工种的投保方案建议，您知道吗？
				<br />
				<span style="color: red">为了更顺畅地使用本系统，提醒您尽快完成本系统的操作指引的阅读，解锁更多实用功能！</span>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="goNewGuidance">马上了解</el-button>
				<el-button type="default" @click="maintenanceFlag = false">太忙了，稍后再看</el-button>
			</span>
		</el-dialog>

		<!--    新市民引流-->
		<XsmYinLiuDialog ref="refXsmYinLiu" :interData="{orderId, act, stagingId}"></XsmYinLiuDialog>
	</basic-container>
</template>

<script>
import {
	optionEmployee,
	optionEmployee_NoProfession,
	optionEmployeeView,
	optionEmployeeView_car_14,
	optionEmployeeView_NoProfession,
	optionPayOffline,
	optionRepeatEmployee,
} from '@/const/crud/insurance/policy'
import {insureMap} from '@/const/crud/insurance/product'

import {
	addStaging,
	calcPremium,
	canPayOffline,
	checkIdNo,
	checkInsure,
	endorseAdd,
	getChannelMainInfo,
	getPolicyDetails,
	getPolicyEmpTemp,
	getProfessionTreeWithQuery,
	getRenewPolicy,
	getRepeatEmpList,
	getResubmitPolicy,
	getStagingDetail,
	insure,
	pay,
	payOffline,
} from '@/api/insurance/policy'
import {getProductPrice, getProfessionHistory} from '@/api/insurance/product'

import {setStore} from '@/util/store'

import _ from 'lodash'
import {isIdCardNoValid} from '@/util/validateRules'
import FloatImgBtn from '../../../components/ui/floatBtn.vue'
import InsuredNotice from '../product/insuredNotice.vue'
import UnitForm from './entry/unitForm.vue'
import PlanForm from './entry/planForm.vue'
import PeriodForm from './entry/periodForm.vue'
import PeriodEndorseForm from './entry/periodEndorseForm.vue'
import InvoiceForm from './entry/invoiceForm.vue'
import InvoiceView from './entry/invoiceView.vue'
import RepeatEmpsDlg from './entry/repeatEmpsDlg.vue'
import {currentYYYYmmdd, toYYYYmmdd, toYYYYmmddFullDate} from '@/util/date'
import {handleDownCategoryFile} from '@/util/util'
import PayerInfo from '@/components/insurance/payerInfo'
import CarForm from '@/views/insurance/policy/entry/carForm'
import rrlog from '@meibao/traceback-record'
import RepeatCarDlg from '@/views/insurance/policy/entry/repeatCarDlg'
import CustomNotice from '@/views/insurance/product/insuredNotice/customNotice'
import {huisuAble} from '@/mixins/huisuAble'
import {queryCompletionList} from '@/api/newGuidance/newGuidance'
import {mapGetters} from 'vuex'
import {
	isAnZe15,
	isAnZeJianzhu,
	isAnZePower,
	isAnZeProduct,
	isFgkDoor,
	isFgkGang,
	isFgkGuangfu,
	isGuoShouCai,
	isJiaDian,
	isJiaDianLong,
	isJiaDianOneYear,
	isMeiYaC,
	isRenBao,
	isXsmYunShu,
	isXsmZhiZao,
} from '@/util/productUtil'
import UnitInsuredForm from '@/views/insurance/policy/entry/unitInsuredForm'
import {getPageId} from '@/util/commonUtils'
import FileConfirm from '@/views/insurance/policy/entry/fileConfirm.vue'
import XsmYinLiuDialog from '@/components/insurance/xsmYinLiuDialog.vue'
import {getFgkDiantiPeriod} from '@/util/channelUtil'
import {isPayToNewWindow} from 'meibao-insure/src/util/productUtil'

export default {
	components: {
		FileConfirm,
		XsmYinLiuDialog,
		UnitInsuredForm,
		CustomNotice,
		RepeatCarDlg,
		CarForm,
		PayerInfo,
		'float-btn': FloatImgBtn,
		'insured-notice': InsuredNotice,
		'unit-form': UnitForm,
		'plan-form': PlanForm,
		'period-form': PeriodForm,
		'period-endorse-form': PeriodEndorseForm,
		'invoice-form': InvoiceForm,
		'invoice-view': InvoiceView,
		'repeat-emps-dlg': RepeatEmpsDlg,
	},
	mounted() {
		this.checkNewGuidance()
	},
	data() {
		return {
			maintenanceFlag: false,
			pageId: '',
			payOrderId: '',
			orderId: '',
			act: '',
			orderDetails: {},
			endorseOrderId: '',
			policyNo: '',
			stagingId: '',
			isAddStaging: false,
			isEndorsement: false,
			unitHint: '无名称（或名称为*）的个体工商户请使用“经营者”姓名作为营业执照名称',

			currentStep: '0',

			//  Product related
			productCode: '',
			productName: '',
			product: {
				id: '',
				type: '',
				name: [],
				holder: {},
				plan: {},
				period: {
					periodList: [],
				},
				employee: {},
				invoice: {},
				payOffline: {},
			},

			//  Employee section
			employeeLoading: false,
			optionEmployee: {},
			optionsProfession: [],
			optionsProfessionAll: [],
			optionsProfessionFiltered: [],
			formEmployee: {
				isSubmitted: false,
				isLoading: false,
			},
			professionHistoryList: [],
			dataEmployee: [],
			page: {
				total: 0,
				currentPage: 1,
				pageSize: 10,
			},
			totalPrice: 0,

			//  Plan section
			minEffectiveDate: null,
			maxEffectiveDate: null,
			professionLevel: null,
			//在线和对公
			allowOnline: true,
			allowOffline: true,

			//  Period section
			endorseBasePrice: '',
			shortRatesList: [],

			checkListStatement: [],

			//  Step confirm
			warningMessage: '',
			optionEmployeeView: {},
			//  相同投保人员在不同网点投保
			repeatEmpListDialogVisible: false,
			tableLoadingRepeatEmpList: false,
			optionRepeatEmployee: this.deepClone(optionRepeatEmployee),
			repeatEmpList: [],

			//  Step Pay
			isCheckingInsure: false,
			isPay: false,
			paySource: 1,
			optionPayOffline: this.deepClone(optionPayOffline),
			formPayOffline: {},
			payOnlineWarningChecked: false,
			payOfflineWarning1Checked: false,
			payOfflineWarning2Checked: false,
			imageTransferCertificate: '',
			fileTransferCertificate: null,

			//  最终提交的投保信息
			formSubmit: {
				emps: [],
				invoice: {},
				toubao: {
					unit_name: null,
				},
				beibao: {
					unit_name: null,
				},
				sameUnit: true,
				strEffectiveDate: null,
				strExpiryDate: null,
				term: null,
				vehs: [],

				isHolderSubmitted: false,
				isInsuredSubmitted: false,
				isPlanSubmitted: false,
				isPeriodSubmitted: false,
				isInvoiceSubmitted: false,
				isCarSubmitted: false,

				getOrder: function () {
					let order = {}

					order.productType = this.productId
					order.effectiveDate = this.effectiveDate
					order.expiryDate = this.expiryDate
					order.term = this.term
					order.feeRate = this.feeRate

					return order
				},
			},
			//下载模板loading
			isDownLoading: false,

			//缓存上次处理的code数据
			lastSaveProfessionData: [],
			lastSaveProfessionCode: [],

			//  Added by Li Yong on 2022/03/07
			isBatchImporting: false,
			isInitOver: false,
			//是否显示对公支付  泛高空 2000一下，通过接口判断
			isShowOfflinePayFan: true,
			//是否需要重新计算保费
			isNeedCalcPremium: false,
			//美亚投保人声明盖章件
			myInsureConfirm: {},
			//美亚付款人信息
			myPayerInfo: {},
			//动态获取方案
			planCoverage: [],
			//阅读完显示
			isShowInsuredBtn: false,
			feeRateDicData: [
				{
					label: '不涉高',
					value: '0',
				},
				{
					label: '涉高',
					value: '1',
				},
			],
			//轮询次数
			pollingCount: 0,
			//引流进入
			isYinliu: false,
		}
	},
	mixins: [huisuAble],
	watch: {
		'dataEmployee.length': {
			handler(newVal, oldVal) {
				if (!this.isBatchImporting && newVal > 0) {
					let minCount = !this.isEndorsement ? this.product.employee.minEmployeeCount : 1
					if (newVal < minCount && newVal < oldVal) {
						let msg = '投保人员不能少于' + this.product.employee.minEmployeeCount + '人'
						this.$alert(msg, '提示', {
							confirmButtonText: '确定',
						})
					}

					this.calcAllEmployeePremium()
				}
			},
		},
	},

	computed: {
		...mapGetters(['userInfo']),
		everythingConfirmed() {
			let isConfirmed = false
			//判断是否是车意险
			let tempCarOrEmp = this.product.isInsureCar ? this.formSubmit.isCarSubmitted : this.formEmployee.isSubmitted
			if (this.isEndorsement) {
				isConfirmed = this.formSubmit.isPeriodSubmitted && tempCarOrEmp && this.formSubmit.isInvoiceSubmitted
			} else {
				let isUnitsSubmitted =
					this.formSubmit.isHolderSubmitted && (this.formSubmit.sameUnit ? true : this.formSubmit.isInsuredSubmitted)
				let isShowFile = true
				if (this.$refs.refFiles) {
					isShowFile = this.$refs.refFiles.onJudgeFileConfirm()
				}
				isConfirmed =
					this.checkListStatement.length == 2 &&
					isUnitsSubmitted &&
					this.formSubmit.isPlanSubmitted &&
					this.formSubmit.isPeriodSubmitted &&
					tempCarOrEmp &&
					this.formSubmit.isInvoiceSubmitted &&
					isShowFile
			}
			return isConfirmed
		},
		//处理title
		onGetTitleContent() {
			if (this.product.type && isRenBao(this.product.type)) {
				return ['投保人（上传身份证可自动识别人员信息）', '被保险人同投保人', '保司要求投保人与被保人必须为同一人！']
			} else {
				return [
					'投保企业（上传营业执照可自动识别企业信息）',
					'被保企业同投保企业',
					'保司要求投保企业与被保企业必须为同一单位！',
				]
			}
		},
	},
	created() {
		this.calcAllEmployeePremium = _.debounce(this.calcAllEmployeePremium, 500)
		this.init()
	},
	methods: {
		//检测是否需要完成新人指引任务
		checkNewGuidance() {
			//1672502400000 2023年一月一日的时间戳  以后注册的需要做新人首次指引任务
			let {distAccount = {}} = this.userInfo || {}
			if (this.validatenull(distAccount.createdAt)) {
				return
			}
			if (new Date(distAccount.createdAt).getTime() - 1672502400000 > 0) {
				//查询判断新人指引任务是否都完成
				queryCompletionList({})
					.then(({data}) => {
						if (data.code == 0) {
							let completionData = data.data
							//找到有未完成的新人指引任务
							if (
								completionData.length > 0 &&
								completionData.findIndex((item) => item.status == 0 && !item.completed) != -1
							) {
								this.maintenanceFlag = true
							} else {
								this.maintenanceFlag = false
							}
						}
					})
					.catch(() => {})
			} else {
				this.maintenanceFlag = false
			}
		},
		//前往新人投保指引
		goNewGuidance() {
			this.maintenanceFlag = false
			this.$router.$avueRouter.closeTag()
			this.$router.push({path: '/insurance/product/newGuidance/guidanceIndex'})
		},
		//
		//  初始化相关
		//
		init() {
			//  对于续保、重新提交并使用旧pid的保单，需要先切换为新pid
			this.product.id = parseInt(this.$route.params.id || '')
			this.productCode = this.$route.query.productCode || ''
			this.act = this.$route.query.act || ''
			this.orderId = this.$route.query.orderId || ''
			this.stagingId = this.$route.query.stagingId || ''
			this.pageId = this.validatenull(this.$route.query.pageId) ? getPageId() : this.$route.query.pageId
			this.isYinliu = this.$route.query.isYinliu || false

			let insureType = parseInt(this.$route.query.insureType || '')
			let insureConfig = {}
			if (!this.validatenull(insureType)) {
				insureConfig = insureMap.get(insureType) || {}
				if (this.act !== 'add' && !this.validatenull(insureConfig)) {
					Object.assign(this.product, insureConfig)
					//处理过期的id
					this.onDiffProductId(insureType, insureConfig)
				}
			}

			// if ((this.act == 'add') && !this.validatenull(this.orderId)) {
			//     Object.assign(categoryQuery, {orderId: this.orderId})
			//
			//     getProfessionHistory(this.product.id, categoryQuery).then(response => {
			//         this.professionHistoryList = response.data.data.hisList || []
			//     })
			// }
			// getProfessionTreeWithQuery(this.product.id, categoryQuery).then(response => {
			//     this.optionsProfession = response.data.data
			// }).catch(() => {
			// }).finally(() => {
			//     this.employeeLoading = false
			// });

			//如果不显示工种则不调用
			if (this.validatenull(insureConfig) || insureConfig.employee.showEmployeeProfession) {
				//  获取当前产品的三级职业分类
				this.employeeLoading = true
				let categoryQuery = {}
				if (this.act === 'add') {
					if (this.validatenull(this.orderId)) {
						this.$message.error('订单号有误！')
						return
					}
					Object.assign(categoryQuery, {orderId: this.orderId})

					Promise.all([
						getProfessionTreeWithQuery(this.product.id, categoryQuery),
						getProfessionHistory(this.product.id, categoryQuery),
					])
						.then((response) => {
							if (this.validatenull(response) || response.length <= 0) {
								this.$message.error('工种数据有误！')
								return
							}
							this.optionsProfession = response[0].data.data || []
							this.professionHistoryList = response[1].data.data.hisList || []

							if (this.professionHistoryList.length > 0) {
								for (let hisItem of this.professionHistoryList) {
									//解构
									let {parentCode = '', categoryName = '', type = '', categoryCode: categoryCodeHis} = hisItem
									//改名字
									hisItem.categoryName = `${categoryName}（批增工种）`
									let isAdd = false
									this.optionsProfession.forEach(({children: childrenWai = []}, waiIndex) => {
										childrenWai.forEach(({children: childrenNei = []}) => {
											let tempIndex = childrenNei.findIndex(({categoryCode: categoryCodeNew = ''}) => {
												//处理泰康和电梯工种变化
												if (isAnZeProduct(insureType)) {
													if (categoryCodeHis.charAt(0) !== 'A') {
														categoryCodeHis = categoryCodeHis.replace('0', 'A')
													}
													if (categoryCodeNew.charAt(0) !== 'A') {
														categoryCodeNew = categoryCodeNew.replace('0', 'A')
													}
												}
												return categoryCodeNew === categoryCodeHis || categoryCodeNew === `0${categoryCodeHis}`
											})
											if (tempIndex !== -1) {
												console.log('删除新工种里的数据-----', childrenNei[tempIndex])
												childrenNei.splice(tempIndex, 1)
												childrenNei.push(hisItem)
												isAdd = true
											}
										})
									})
									//如果没加进去，则需要创建节点
									if (!isAdd) {
										//查找第一个存在的数据
										let tempData =
											this.optionsProfession.find(
												(itemDataWai = {}) => itemDataWai.children && itemDataWai.children.length > 0,
											) || null
										if (tempData) {
											tempData.children.push({
												categoryName: type,
												categoryCode: parentCode,
												children: [this.deepClone(hisItem)],
											})
										}
									}
								}
							}
							this.dealProfessionLevel()
						})
						.catch(() => {})
						.finally(() => {
							this.employeeLoading = false
						})
				} else {
					getProfessionTreeWithQuery(this.product.id)
						.then((response) => {
							this.optionsProfession = response.data.data
							this.dealProfessionLevel()
						})
						.catch(() => {})
						.finally(() => {
							this.employeeLoading = false
						})
				}
			}
			//保险条款显示处理
			this.isShowInsuredBtn = !this.product.isShowPdfInsured
			// if (this.product.type === 13 || this.product.type === 17 || this.product.type === 7) {
			//   this.isShowInsuredBtn = true
			// }
			//如果为16新市民
			if (this.product.type === 16) {
				this.unitHint = '该保险产品仅限营业执照注册地为广东的企业投保'
			}
			//  获取保险起期范围
			let query = {
				pid: this.product.id,
			}
			//  只在批增时才需要设置
			if (this.act === 'add') {
				query.flag = 1
				//  Added by Li Yong on 2021/12/23
				if (!this.validatenull(this.orderId)) {
					query.orderId = this.orderId
				}
			}
			// if (!this.validatenull(this.orderId) && this.act!='renew') {
			//     query.orderId = this.orderId
			// }
			getProductPrice(query)
				.then((response) => {
					if (this.validatenull(response) || this.validatenull(response.data)) {
						this.$message.error('获取险种金额有误')
						return
					}
					let priceArr = response.data.data
					if (this.validatenull(priceArr) || priceArr.length <= 0) {
						this.$message.error('获取险种金额有误!')
						return
					}
					let {
						type = 0,
						minEffectiveDate = '',
						maxEffectiveDate = '',
						vo = '',
						shortRateMaps = {},
						shortFeeMaps = {},
						code = '',
						insureConfig: {
							allowInsureConfirm = false,
							requiredInsureConfirm = false,
							allowOnline = true,
							allowOffline = true,
							offpayConfig = {},
						},
						productId = '',
					} = priceArr[0]
					//时间
					this.minEffectiveDate = Date.parse(minEffectiveDate)
					this.maxEffectiveDate = Date.parse(maxEffectiveDate)
					//如果为美亚
					if (type === 13) {
						if (allowInsureConfirm || requiredInsureConfirm) {
							this.myInsureConfirm = {
								allowInsureConfirm,
								requiredInsureConfirm,
								email: true,
							}
						}
					} else if (type === 15) {
						this.myInsureConfirm = {
							allowInsureConfirm: true,
							requiredInsureConfirm: true,
						}
					}
					let tempShortData = {}
					if (!this.validatenull(shortFeeMaps)) {
						tempShortData = shortFeeMaps
					} else if (!this.validatenull(shortRateMaps)) {
						tempShortData = shortRateMaps
					}
					//处理选择期限
					if (!this.validatenull(tempShortData)) {
						let tempPeriodList = []
						for (let value in tempShortData) {
							let tempData = {value: parseInt(value)}
							if (value == 12) {
								tempData.label = '1年'
							} else {
								tempData.label = `${value}个月`
							}
							//泛高空钢结构去除12月！！！！！
							if (value != 12 || !isFgkGang(productId)) {
								tempPeriodList.push(tempData)
							}
						}
						this.product.period.periodList = getFgkDiantiPeriod(tempPeriodList, type)
					} else {
						//家电长期 1年
						if (isJiaDianOneYear(this.product.type)) {
							this.product.period.periodList = [{value: 12, label: '1年'}]
						}
					}
					this.planCoverage = []
					//处理投保金额
					priceArr.forEach(({coverage}) => {
						if (!this.planCoverage.includes(coverage)) {
							this.planCoverage.push(coverage)
						}
					})
					//在线和对公支付
					if (!allowOnline || !allowOffline) {
						this.allowOnline = allowOnline
						this.allowOffline = allowOffline
					}
					if (this.allowOffline && !this.validatenull(offpayConfig)) {
						//存在对公支付
						this.formPayOffline = offpayConfig
					}
					if (!this.validatenull(query.orderId) && !this.validatenull(vo)) {
						//批增
						let {scope = '', priceId = ''} = vo
						if (type === 9) {
							if (!this.validatenull(scope)) {
								this.professionLevel = scope - 11
							}
						}
						if (type === 10) {
							this.shortRatesList = tempShortData
						}

						if (!this.validatenull(priceId)) {
							let currentPrice = priceArr.find(({id = ''}) => {
								return id === priceId
							})
							if (!this.validatenull(currentPrice)) {
								this.endorseBasePrice = currentPrice.price
								this.formSubmit.coverage = currentPrice.coverage
							}
							//
							// priceArr.forEach((item, index) => {
							//   if (item.id == priceId) {
							//     this.endorseBasePrice = item.price
							//   }
							// })
						}
					}
					if (this.validatenull(this.productCode)) {
						this.productCode = code
					}
					this.initInsureData(type)
					//判断是否不能处理回溯
					this.isJudgeHuisu()
				})
				.catch(() => {})
				.finally(() => {
					this.isInitOver = true
				})
		},
		//获取的职业列表 进行等级处理
		dealProfessionLevel() {
			if (!this.validatenull(this.optionsProfession) && this.optionsProfession.length > 0) {
				this.optionsProfession.forEach((childWai) => {
					if (childWai) {
						let {children = []} = childWai
						if (children.length > 0) {
							children.forEach((childNei) => {
								if (childNei) {
									let {children = []} = childNei
									children.forEach((childNeiNei) => {
										if (childNeiNei) {
											let {categoryName, professionLevel} = childNeiNei
											childNeiNei.categoryName = `${categoryName} - ${professionLevel}类`
										}
									})
								}
							})
						}
					}
				})
			}
		},
		//处理不同产品
		onDiffProductId(insureType, insureConfig) {
			//处理不同的ID
			if (!insureConfig.currentId.includes(this.product.id)) {
				if (!this.validatenull(this.productCode)) {
					switch (insureType) {
						case 9:
							this.product.id = insureConfig.currentId[this.productCode.indexOf('HIGH') !== -1 ? 1 : 0]
							break
						case 11:
							this.product.id = insureConfig.currentId[this.productCode.indexOf('CS') !== -1 ? 1 : 0]
							break
						case 13:
							if (isMeiYaC(insureType, this.product.id)) {
								this.product.id = insureConfig.currentId[this.productCode.indexOf('ZF') !== -1 ? 1 : 0]
							} else {
								this.product.id = insureConfig.currentId[0]
							}
							break
						case 17:
							//"HIGH-CPIC-GD-PRO-100-24H"  236
							//"HIGH-CPIC-GD-PRO-120-THIRD-24H"  237
							this.product.id = insureConfig.currentId[this.productCode.indexOf('THIRD') !== -1 ? 1 : 0]
							break
						case 6:
							if (!insureConfig.currentId.includes(this.product.id)) {
								this.product.id = insureConfig.currentId[0]
							}
							break
						default:
							this.product.id = insureConfig.currentId[0]
							break
					}
				} else {
					//泛高空改版
					if (insureType === 6) {
						if (!insureConfig.currentId.includes(this.product.id)) {
							this.product.id = insureConfig.currentId[0]
						}
					} else {
						this.product.id = insureConfig.currentId[0]
					}
				}
			}
		},

		initInsureData(insureType) {
			let insureConfig = insureMap.get(insureType) || {}
			this.$delete(insureConfig, 'period')
			if (!this.validatenull(insureConfig)) {
				Object.assign(this.product, insureConfig)
				// Added by Li Yong on 2022/1/5
				if (this.act === 'staging') {
					// this.product.id != insureConfig.currentId[0]
					//处理过期的id
					this.onDiffProductId(insureType, insureConfig)
					//家电长期 1年
					if (this.product.type === 17) {
						this.product.period.periodList = [{value: 12, label: '1年'}]
					}
				}

				//  Added by Li Yong on 2021/12/30
				if (!this.validatenull(insureConfig.insureDisabled)) {
					if (
						insureConfig.insureDisabled &&
						(this.act === 'new' || this.act === 'renew' || this.act === 'resubmit' || this.act === 'staging')
					) {
						// this.$message({
						//     message: '该产品已下架，仅支持存续保单的批增和批改。',
						//     type: 'warning'
						// });
						// this.$nextTick(() => {
						//     this.$router.$avueRouter.closeTag()
						// })
						this.$alert('该产品已下架，仅支持存续保单的批增及替换。', '提示', {
							showClose: false,
							confirmButtonText: '确定',
							callback: (action) => {
								this.$router.$avueRouter.closeTag()
								this.$router.push({path: '/insurance/policy/index'})
							},
						})
					}
				}

				this.formSubmit.productId = this.product.id
				//批增不走这个逻辑
				if (this.act !== 'add') {
					if (insureType === 9) {
						this.productName = this.product.name[this.productCode.indexOf('HIGH') != -1 ? 1 : 0]
					} else {
						this.productName = this.product.name[0]
						if (insureType === 6 || insureType === 13 || insureType === 12) {
							let index = insureConfig.currentId.findIndex((itemData) => {
								return itemData === this.product.id
							})
							if (index !== -1) {
								this.productName = this.product.name[index]
							} else {
								if (!this.validatenull(this.product.customName)) {
									this.productName = this.product.customName
								}
							}
						}
					}
				}
				if (this.product.employee.showEmployeeProfession) {
					this.optionEmployee = this.deepClone(optionEmployee)
					this.optionEmployeeView = this.deepClone(optionEmployeeView)
				} else {
					if (this.product.isInsureCar) {
						this.optionEmployeeView = this.deepClone(optionEmployeeView_car_14)
					} else {
						this.optionEmployee = this.deepClone(optionEmployee_NoProfession)
						this.optionEmployeeView = this.deepClone(optionEmployeeView_NoProfession)
					}
				}
				//如果为国寿财，则隐藏保费
				if (isGuoShouCai(insureType)) {
					let tempPremium = this.findObject(this.optionEmployeeView.column, 'premium') || {}
					tempPremium.hide = true
				}
				//如果为安泽1-5，则显示涉高
				if (isAnZe15(insureType)) {
					let tempFeeRate = this.findObject(this.optionEmployee.column, 'feeRate') || {}
					tempFeeRate.hide = false
				}
				// Object.assign(this.formPayOffline, this.product.payOffline)

				this.formSubmit.sameUnit = this.act === 'new'
				switch (this.act) {
					case 'new':
						for (let i = 0; i < this.product.employee.minEmployeeCount; i++) {
							let employee = {
								name: '',
								idNo: '',
								premium: 0,
								$cellEdit: true,
							}
							this.dataEmployee.push(employee)
						}
						break
					case 'staging':
						getStagingDetail(this.stagingId)
							.then((response) => {
								this.prefillByPolicyData(response.data.data)
							})
							.catch(() => {})
							.finally(() => {})
						//保险条款显示处理
						this.isShowInsuredBtn = !this.product.isShowPdfInsured
						// if (this.product.type === 13 || this.product.type === 17 || this.product.type === 7) {
						//   this.isShowInsuredBtn = true
						// }
						break
					case 'resubmit':
						getResubmitPolicy(this.orderId)
							.then((response) => {
								let data = response.data.data
								if (!this.validatenull(data)) {
									if (insureType === 9) {
										this.deduceProfessionLevel(data)
									}
									this.prefillByPolicyData(data)
								}
							})
							.catch(() => {})
							.finally(() => {})
						break
					case 'renew':
						getRenewPolicy(this.orderId)
							.then((response) => {
								let policyData = response.data.data
								this.policyNo = policyData.policyNo
								if (!this.validatenull(policyData.effectiveDate)) {
									policyData.effectiveDate = toYYYYmmdd(policyData.effectiveDate)
									// this.minEffectiveDate = Date.parse(policyData.effectiveDate.replaceAll('-', '/'))
									let minRenewEffectiveDate = Date.parse(policyData.effectiveDate.replace(/-/g, '/'))
									if (minRenewEffectiveDate > this.minEffectiveDate) {
										this.minEffectiveDate = minRenewEffectiveDate
									}
								}
								this.prefillByPolicyData(policyData)
							})
							.catch(() => {})
							.finally(() => {})
						break
					case 'add':
						this.isEndorsement = true

						this.formSubmit.isHolderSubmitted = true
						this.formSubmit.isInsuredSubmitted = true
						this.formSubmit.isPlanSubmitted = true

						let employee = {
							name: '',
							idNo: '',
							premium: 0,
							$cellEdit: true,
						}
						this.dataEmployee.push(employee)

						getPolicyDetails(this.orderId)
							.then((response) => {
								this.orderDetails = response.data.data
								if (this.validatenull(this.orderDetails)) {
									this.$message.error('保单详情数据有误！')
									return
								}
								let {
									productName = '',
									expiryDate,
									effectiveDate,
									term,
									productCode = '',
									feeRate = '',
									addMaim = '',
									holder: {unitName = ''},
									invoice: {invoiceTitle = ''},
									insureType = 0,
									productId = 0,
								} = this.orderDetails
								//批增标题
								this.productName = productName

								if (!expiryDate.includes('-')) {
									this.orderDetails.expiryDate = toYYYYmmddFullDate(expiryDate)
									effectiveDate = toYYYYmmdd(effectiveDate)
								}

								this.formSubmit.toubao.unit_name = unitName

								let plan = this.$refs.plan
								if (plan != null) {
									let data = {}
									//处理coverage  更改获取coverage 方式，通过 price接口处理
									if (this.validatenull(this.formSubmit.coverage)) {
										let arr = productCode.split('-')
										data.coverage = parseInt(arr.pop())
										this.formSubmit.coverage = data.coverage
									} else {
										data.coverage = this.formSubmit.coverage
									}
									if (!this.validatenull(this.professionLevel)) {
										data.professionLevel = this.professionLevel
									}
									data.feeRate = feeRate
									data.addMaim = addMaim
									//泛高空光伏处理扩展
									if (insureType === 6 && (isFgkGuangfu(productId) || isFgkDoor(productId))) {
										data.addMaim = productCode.indexOf('PRO') > -1 ? '1' : '0'
									} else if (insureType === 13) {
										//美亚
										//旧方案不显示
										if (isMeiYaC(insureType, productId)) {
											data.costDuty = productCode.indexOf('ZF') > -1 ? '1' : '0'
										} else {
											plan.hideCostDuty()
										}
									} else if (insureType === 17) {
										//家电处理
										data.thirdDuty = productCode.indexOf('THIRD') > -1 ? '1' : '0'
									} else if (isAnZe15(insureType)) {
										//安责1-5
										data.addMaim = productCode.indexOf('PRO') > -1 ? '1' : '0'
										data.allDuty = productCode.indexOf('24H') > -1 ? '1' : '0'
									} else if (isXsmYunShu(insureType)) {
										data.allDuty = productCode.indexOf('HIGH-CPIC-GD-PRO') > -1 ? '1' : '0'
									}
									plan.setData(data)
								}

								let period = this.$refs.periodEndorse
								if (period != null) {
									let data = {
										defeasanceDate: this.orderDetails.expiryDate,
										effectiveBeginDate: effectiveDate,
										term,
									}
									period.setData(data)
								}

								let invoice = this.$refs.invoice
								if (invoice != null) {
									let data = {
										identification: invoiceTitle,
										title: unitName,
									}
									invoice.setData(data)
								}
							})
							.catch(() => {})
							.finally(() => {})
						break
				}
			} else {
				this.$alert('不支持的产品类型', '错误', {
					confirmButtonText: '确定',
					callback: (action) => {},
				})
			}
		},
		deduceProfessionLevel(data) {
			if (!this.validatenull(data.emps)) {
				let highestLevel = 0
				data.emps.forEach((item) => {
					let empLevel = item.category.professionLevel
					if (!this.validatenull(empLevel)) {
						if (parseInt(empLevel) > highestLevel) {
							highestLevel = parseInt(empLevel)
						}
					}
				})
				if (highestLevel == 1) {
					highestLevel = 2
				}
				this.professionLevel = highestLevel
			}
		},

		prefillByPolicyData(policyData) {
			//  投、被保企业
			this.formSubmit.sameUnit = policyData.sameUnit

			let holder = this.$refs.holder
			let insured = this.$refs.insured
			if (holder != null) {
				holder.setData(policyData.toubao)
			}
			if (!this.formSubmit.sameUnit && insured != null) {
				insured.setData(policyData.beibao)
			}
			//处理共同被保险人
			if (!this.validatenull(policyData.joinList)) {
				if (this.$refs.unitInsured) {
					this.$refs.unitInsured.onSetGongBaoData(policyData.joinList)
				}
			}

			//  投保方案
			let plan = this.$refs.plan
			if (plan != null) {
				let planData = {
					coverage: policyData.coverage,
					feeRate: policyData.feeRate || '',
				}

				if (!this.validatenull(this.professionLevel)) {
					planData.professionLevel = this.professionLevel
				}

				if (!this.validatenull(policyData.professionLevel)) {
					planData.professionLevel = policyData.professionLevel
				}

				if (this.act === 'staging') {
					if (this.product.plan.insureSuddenDeath) {
						if (this.product.id == this.product.plan.idSuddenDeath) {
							planData.insureSuddenDeath = 1
						}
					}
				}
				// //美亚处理扩展自费药
				// if (policyData.insureType === 13) {
				//   planData.costDuty = policyData.productId === 203 ? '0': '1'
				// }

				this.formSubmit.insureSuddenDeath = planData.insureSuddenDeath || ''

				plan.setData(planData)
			}

			//  保险期限
			let period = this.$refs.period
			if (period != null) {
				let data = {}
				// if (!this.validatenull(policyData.effectiveDate)) {
				//   policyData.effectiveDate = toYYYYmmdd(policyData.effectiveDate)
				//   data.effectiveDate = new Date(policyData.effectiveDate.replace(/-/g, '/'))
				// }
				if (this.act !== 'renew') {
					data.period = policyData.term
				}
				period.setData(data)
			}

			//  投保人员
			this.totalPrice = 0
			let emps = policyData.emps || []
			if (!this.validatenull(emps)) {
				if (emps.length >= 60) {
					let tempProfession = this.findObject(this.optionEmployee.column, 'profession')
					if (tempProfession && tempProfession !== -1) {
						tempProfession.hide = true
					}
					let tempProfession1 = this.findObject(this.optionEmployee.column, 'professionTemp')
					if (tempProfession1 && tempProfession1 !== -1) {
						tempProfession1.hide = false
					}
				}
				this.dataEmployee.length = 0
				emps.forEach((item, index) => {
					let emp = {
						name: item.empName,
						idNo: item.empIdNo,
						premium: 0,
						profession: [],
						professionTemp: '',
					}
					//引流进入的不处理工种
					if (!this.isYinliu) {
						if (!this.validatenull(item.feeRate)) {
							emp.feeRate = item.feeRate + ''
						}

						if (!this.validatenull(item.professionCode)) {
							emp.profession = this.convertProfessionCode(item.professionCode)
							let professionData = this.getProfessionByCode(emp.profession) || {}
							emp.level = professionData.professionLevel || ''
							if (emps.length >= 60 && this.product.employee.showEmployeeProfession) {
								emp.professionTemp = professionData.categoryName
							}
							//判断是否为安责1-5类
							if (isAnZe15(this.product.type) && !this.validatenull(emp.level)) {
								//处理涉高
								emp = this.onDealFeeRate(emp.level, emp)
							}
						}
					}
					emp.$cellEdit = true
					this.dataEmployee.push(emp)
				})
			}

			if (this.dataEmployee.length < this.product.employee.minEmployeeCount) {
				let count = this.product.employee.minEmployeeCount - this.dataEmployee.length
				let i = 0
				while (i < count) {
					let employee = {
						name: '',
						idNo: '',
						premium: 0,
						$cellEdit: true,
					}
					this.dataEmployee.push(employee)
					i++
				}
			}
			//处理阳光驾意险
			let tempCarForm = this.$refs.carForm
			if (tempCarForm && policyData.vehs.length > 0) {
				tempCarForm.setDataCarForm(policyData.vehs)
			}

			//  发票
			let invoice = this.$refs.invoice
			if (invoice != null) {
				let invoiceData = {}

				Object.assign(invoiceData, policyData.invoice)
				;(invoiceData.title = this.validatenull(policyData.invoice.title)
					? policyData.toubao.unit_name
					: policyData.invoice.title),
					(invoiceData.identification = this.validatenull(policyData.invoice.identification)
						? policyData.toubao.unit_code
						: policyData.invoice.identification)
				invoiceData.money = 0

				invoice.setData(invoiceData)
			}

			this.calcAllEmployeePremium()
		},

		//
		//  投保流程
		//

		//
		//  Step1:  保单录入
		//

		//  返回修改保单步骤
		handleStepInsure() {
			this.currentStep = '0'
			this.payOrderId = ''
			//如果存在重复投保提示 提示去掉
			this.dataEmployee.forEach((itemData) => {
				if (!this.validatenull(itemData.remark)) {
					itemData.remark = ''
				}
			})
		},

		//
		//  投/被保企业
		//
		//  发票抬头、税号和投保企业联动
		handleSameUnitChanged(val) {
			this.formSubmit.sameUnit = val
			//如果企业信息已确认，则恢复
			this.$refs.holder.modifyUnit()
		},
		onHolderSubmitted(submitData) {
			this.formSubmit.isHolderSubmitted = true

			Object.assign(this.formSubmit.toubao, submitData)

			//如果是人保，还得判断填充人员数据！！！
			if (isRenBao(this.product.type) && this.act === 'new') {
				let {unit_name = '', unit_code = ''} = submitData
				//判断是否已经在人员中了！！！
				if (this.dataEmployee.length === 1 && !this.dataEmployee[0].idNo) {
					this.dataEmployee[0].name = unit_name
					this.dataEmployee[0].idNo = unit_code
				}
			}
			if (this.formSubmit.sameUnit) {
				Object.assign(this.formSubmit.beibao, submitData)
			}
			//   发票抬头、税号联动
			let invoice = this.$refs.invoice
			if (invoice != null) {
				let data = {
					identification: submitData.unit_code,
					title: submitData.unit_name,
				}
				if (submitData.certType === '100' && this.product.id == 14) {
					data.title = '个人'
				}
				invoice.setData(data)
			}
			//判断是否不能投年单
			let period = this.$refs.period
			if (period) {
				if (submitData.isNoYear) {
					//处理生效时间,保险期限 去掉年
					period.removeYear()
				} else {
					//是否之前处理过年保单
					period.addYear()
				}
			}
			this.calcAllEmployeePremium()
		},
		onInsuredSubmitted(submitData) {
			this.formSubmit.isInsuredSubmitted = true

			Object.assign(this.formSubmit.beibao, submitData)

			this.calcAllEmployeePremium()
		},

		//
		//  投保方案
		//
		//  确认
		onPlanSubmitted(form) {
			if (!this.validatenull(form)) {
				this.formSubmit.coverage = form.coverage
				this.formSubmit.feeRate = form.feeRate
				if (this.product.type === 15) {
					this.formSubmit.addMaim = form.addMaim
				}
				if (isMeiYaC(this.product.type, this.product.id)) {
					this.formSubmit.costDuty = form.costDuty
				}
			}
			this.formSubmit.isPlanSubmitted = true
		},
		//  鼎和需根据保额筛选可投保工种
		onCategoryFiltered(isFiltered) {
			if (this.validatenull(this.optionsProfessionAll)) {
				this.optionsProfessionAll = this.optionsProfession
				this.optionsProfessionFiltered = this.filterCategoryByLevel(4)
			}

			if (isFiltered) {
				this.dataEmployee.forEach((item, index) => {
					if (!this.validatenull(item.profession)) {
						let profession = this.getProfessionByCode(item.profession)
						if (!this.validatenull(profession)) {
							if (profession.professionLevel > 4) {
								item.profession = []
							}
							item.premium = 0
						}
					}
				})
			}

			this.optionsProfession = isFiltered ? this.optionsProfessionFiltered : this.optionsProfessionAll

			this.calcAllEmployeePremium()
		},
		//  鼎和是否投保猝死对应不同pid
		onInsureSuddenDeath(isInsured, newProductId) {
			this.product.id = newProductId

			this.formSubmit.productId = this.product.id
			this.formSubmit.insureSuddenDeath = isInsured

			this.calcAllEmployeePremium()
		},
		//  亚太职业大类切换需筛选对应可选职业工种
		onProfessionLevelChange(level) {
			if (this.professionLevel != level) {
				this.professionLevel = level
				if (this.dataEmployee.length > 0) {
					let employeeLevel = parseInt(this.dataEmployee[0].level)
					if ((level == 2 && level < employeeLevel) || (level != 2 && level != employeeLevel)) {
						this.dataEmployee.forEach((item, index) => {
							item.profession = []
						})
					}
				}
			}

			this.employeeLoading = true
			//  Modified by Li Yong on 2021/12/23
			//  亚太批增时隐藏工种大类属性，通过接口限制可投保工种
			// let query = {
			//     bigLevel: level - 1,
			// }
			let query = {}
			if (this.act === 'add' && !this.validatenull(this.orderId)) {
				Object.assign(query, {orderId: this.orderId})
			} else {
				Object.assign(query, {bigLevel: level - 1})
			}

			getProfessionTreeWithQuery(this.product.id, query)
				.then((response) => {
					this.optionsProfession = response.data.data || []
				})
				.catch(() => {})
				.finally(() => {
					this.employeeLoading = false
				})
		},

		onPlanChanged() {
			if (this.isInsureRestricted()) {
				let plan = this.$refs.plan
				if (plan != null) {
					plan.setData({coverage: ''})
				}
			} else {
				this.calcAllEmployeePremium()
			}
		},
		onPlanChangeAddMaim() {},

		//
		//  保障期限
		//
		//  确认
		onPeriodSubmitted(data) {
			Object.assign(this.formSubmit, data)
			this.formSubmit.strEffectiveDate = data.effectiveDate + ' 00:00:00'
			this.formSubmit.strExpiryDate = data.expiryDate
			this.formSubmit.term = data.term

			this.formSubmit.isPeriodSubmitted = true
		},

		onPeriodChanged() {
			if (this.isInsureRestricted()) {
				let period = this.$refs.period
				if (period != null) {
					period.setData({period: ''})
				}
			} else {
				this.calcAllEmployeePremium()
			}
		},

		//保障车辆信息
		onSubmitCarData(carData) {
			if (this.validatenull(carData)) {
				this.formSubmit.isCarSubmitted = false
			} else {
				this.formSubmit.isCarSubmitted = true
				this.formSubmit.vehs = carData
				this.calcAllEmployeePremium()
			}
		},

		//
		//  投保人员
		//
		//  平安电梯险投保人员信息无职业工种，根据身份证号试算保费
		employeeCellMouseLeave(row, column, cell, event) {
			if (!this.product.employee.showEmployeeProfession) {
				if (!this.validatenull(row.idNo) && column.property == 'idNo') {
					this.calcAllEmployeePremium()
				}
			} else {
				if (this.isEndorsement && this.product.type == 8) {
					if (!this.validatenull(row.idNo) && column.property == 'idNo') {
						this.calcAllEmployeePremium()
					}
					if (!this.validatenull(row.name) && column.property == 'name') {
						this.calcAllEmployeePremium()
					}
				}
			}
		},
		//  投保人员：修改雇员类别触发
		handleProfessionChange(value) {
			let {$index, profession} = value
			if (!this.validatenull(profession)) {
				//根据险种获取几类工种
				let professionLevel = ''
				if (isAnZe15(this.product.type)) {
					professionLevel = this.getProfessionByCode(profession).professionLevel
				}

				if (this.isInsureRestricted()) {
					this.dataEmployee.forEach((item) => {
						if (item.profession == profession) {
							item.profession = []
						}
					})
					this.$forceUpdate()
				} else {
					//处理当前选择的工种
					this.onDealFeeRate(professionLevel, this.dataEmployee[$index])
					this.dataEmployee.forEach((item, index) => {
						if (this.validatenull(item.profession)) {
							item.profession = profession
							//处理涉高
							this.onDealFeeRate(professionLevel, this.dataEmployee[index])
						}
					})
				}
				this.calcAllEmployeePremium()
			}
		},
		//处理涉高问题
		onDealFeeRate(professionLevel, itemData) {
			//处理涉高
			if (!this.validatenull(professionLevel)) {
				if (parseInt(professionLevel) <= 3) {
					//1到三类，不能选择涉高 "feeRate":0代表不涉高 1 涉高
					if (this.validatenull(itemData.feeRate)) {
						this.$set(itemData, 'feeRate', '0')
					} else {
						itemData.feeRate = '0'
					}
					if (this.validatenull(itemData.feeRateDisabled)) {
						this.$set(itemData, 'feeRateDisabled', true)
					} else {
						itemData.feeRateDisabled = true
					}
				} else {
					// 4-5类
					if (itemData.feeRateDisabled) {
						itemData.feeRateDisabled = false
					}
				}
			}
			return itemData
		},
		//安责1-5类 涉高
		onFeeRateChange(rowData) {
			let {$index, profession: professionCurrent = [], feeRate: feeRateCurrent} = rowData
			//获取当前工种等级
			this.dataEmployee.forEach((itemData, index) => {
				let {profession = '', feeRate = ''} = itemData
				if (feeRate === '' && (profession === '' || professionCurrent[2] === profession[2])) {
					//直接赋值空
					this.$set(itemData, 'feeRate', feeRateCurrent)
				}
			})
			//计算钱
			this.calcAllEmployeePremium()
		},

		//  下载批量导入模板
		handleGetEmployeeTemplate() {
			// 批增 国寿财 需要通过接口下载文档
			if (!this.validatenull(this.orderId) && !isJiaDian(this.product.type)) {
				this.isDownLoading = true
				getPolicyEmpTemp(this.orderId)
					.then((response) => {
						let link = document.createElement('a')
						link.href = window.URL.createObjectURL(new Blob([response.data]))
						link.target = '_blank'
						//文件名和格式
						link.download = `$template_chinalife_${currentYYYYmmdd()}.xlsx`
						document.body.appendChild(link)
						link.click()
						document.body.removeChild(link)
					})
					.catch(() => {})
					.finally(() => {
						this.isDownLoading = false
					})
			} else {
				let templates = this.product.employee.employeeTemplate || []
				if (templates.length > 1) {
					//  亚太团意险需根据职业大类对应不同模板
					if (!this.validatenull(this.professionLevel)) {
						window.open(templates[this.professionLevel - 2])
					} else {
						this.$message({
							message: '请先选择 职业大类',
							type: 'warning',
						})
					}
				} else if (templates.length === 1) {
					window.open(templates[0])
				} else {
					this.isDownLoading = true
					let fileName = `${this.product.id}_template_chinalife_${currentYYYYmmdd()}.xlsx`
					handleDownCategoryFile(
						`/dist/distInsure/categoryDownloadPid
/${this.product.id}`,
						{},
						fileName,
					)
						.then(() => {
							//下载成功
						})
						.catch(() => {})
						.finally(() => {
							this.isDownLoading = false
						})
				}
			}
		},
		//  批量导入
		handleEmployeeFileChange(file, fileList) {
			//  Added by Li Yong on 2022/03/07
			this.isBatchImporting = true
			this.formEmployee.isLoading = true
			this.$Export
				.xlsx(file.raw)
				.then((result) => {
					console.log('批量导入文件内容----', result)
					let {results = []} = result || {}
					if (results.length <= 0) {
						this.$message.error('批量导入文件数据为空！')
						return
					}
					let isMoreNum = false
					let tempResult = []
					//如果导入数量大于50，则只显示工种
					for (let i = 0; i < results.length; i++) {
						let tempItemData = Object.values(results[i]) || []
						if (tempItemData.length >= 3) {
							let [data1, data2, data3] = tempItemData
							if (data1 && typeof data1 == 'number' && data2 && data3) {
								tempResult.push(tempItemData)
							}
						}
					}
					if (tempResult.length <= 0) {
						this.$message.error('批量导入文件数据有误！')
						return
					}

					if (tempResult.length >= 60) {
						isMoreNum = true
						let tempProfession = this.findObject(this.optionEmployee.column, 'profession') || -1
						if (!this.validatenull(tempProfession) && tempProfession !== -1) {
							tempProfession.hide = true
						}
						let tempProfession1 = this.findObject(this.optionEmployee.column, 'professionTemp') || -1
						if (!this.validatenull(tempProfession1) && tempProfession1 !== -1) {
							tempProfession1.hide = false
						}
					}
					let tempData = []
					console.log('批量导入-------', tempResult)
					for (let i = 0; i < tempResult.length; i++) {
						let row = tempResult[i]
						if (typeof row[0] == 'number') {
							let employee = {}
							if (!this.validatenull(row[1]) && row[1] !== ' &&') {
								employee.name = row[1]
								employee.idNo = row[2]
								employee.profession = []
								if (!this.validatenull(row[5]) && row[5] !== ' &&') {
									if (isMoreNum) {
										employee.professionTemp = row[5].split('-')[0]
									}
									let professionCode = row[5].split('-')[1]
									if (!this.validatenull(professionCode)) {
										employee.profession = this.convertProfessionCode(professionCode)
									}
								}
								if (isAnZe15(this.product.type) && row.length > 7 && !this.validatenull(row[7])) {
									let tempLevel = parseInt(row[6].replace('类', ''))
									if (tempLevel <= 3) {
										employee.feeRate = '0'
										employee.feeRateDisabled = true
									} else {
										employee.feeRate = row[7] === '涉高' ? '1' : '0'
									}
								}

								employee.premium = 0
								employee.$cellEdit = true
								tempData.push(employee)
							}
						}
					}
					// 删除空数据
					tempData = this.dataEmployee.concat(tempData).filter((item) => {
						return !this.validatenull(item.name) || !this.validatenull(item.idNo) || !this.validatenull(item.profession)
					})

					this.dataEmployee = tempData

					this.$nextTick(() => {
						if (!isMoreNum) {
							// 触发blur
							document.getElementsByClassName('idNo').forEach(function (element) {
								element.children[0].focus()
								element.children[0].blur()
							})
						}
						// Added by Li Yong on 2021/12/30
						if (this.isInsureRestricted()) {
							let rules = this.product.restriction.rules
							rules.forEach((rule) => {
								if (!this.validatenull(rule.professionCodes)) {
									this.dataEmployee.forEach((employee) => {
										let profession = employee.profession
										if (!this.validatenull(profession) && rule.professionCodes.indexOf(profession[2]) >= 0) {
											this.dataEmployee[j].profession = []
										}
									})
								}
							})
						}
						//

						this.calcAllEmployeePremium()
					})
				})
				.catch(() => {})
				.finally(() => {
					this.formEmployee.isLoading = false
					this.isBatchImporting = false
				})
		},
		//  进入可修改状态
		handleEmployeeModify() {
			this.formEmployee.isSubmitted = false
			this.optionEmployee.header = true
			this.dataEmployee.forEach((item, index) => {
				item.$cellEdit = true
			})
		},
		submitEmployee() {
			let preconditions = [
				{
					condition: this.formSubmit.isHolderSubmitted,
					message: '请先确认 投保企业',
				},
				{
					condition: this.formSubmit.isInsuredSubmitted || this.formSubmit.sameUnit,
					message: '请先确认 被保企业',
				},
				{
					condition: this.formSubmit.isPlanSubmitted,
					message: '请先确认 投保方案',
				},
				{
					condition: this.formSubmit.isPeriodSubmitted,
					message: '请先确认 生效时间',
				},
			]

			for (let i = 0; i < preconditions.length; i++) {
				let precondition = preconditions[i]
				if (!precondition.condition) {
					this.$message.error(precondition.message)
					return
				}
			}

			let tempMaxNum = this.product.employee.maxEmployeeCount || 1000
			if (this.dataEmployee.length > tempMaxNum) {
				this.$message.error(`投保人员不能多于${tempMaxNum}人`)
				return
			}

			let minCount = !this.isEndorsement ? this.product.employee.minEmployeeCount : 1
			if (this.dataEmployee.length < minCount) {
				this.$message.error(`投保人员不能少于${minCount}人`)
				return
			}

			let emps = []
			let empIdx = 0
			let idNoValid = true
			let idNoRepeat = false
			let errIdNo = ''
			let map = {}
			let idNoRepeatData = ''
			let checkIdNoData = []
			let firstScope = {}
			let yunshuSameScope = ''
			//禁止投保
			let rejectIdNo = ''
			for (let index = 0; index < this.dataEmployee.length; index++) {
				let item = this.dataEmployee[index]
				// 过滤空格
				item.name = item.name.replace(/\s+/g, '')
				item.idNo = item.idNo.replace(/\s+/g, '').toUpperCase()

				//如果是安责雇主，则需要判断是否选了涉高！！！
				if (isAnZe15(this.product.type) && this.validatenull(item.feeRate)) {
					this.$alert('请先完成投保人员信息填写', '提示', {
						confirmButtonText: '确定',
					})
					return
				}
				if (!this.validatenull(item.name) && !this.validatenull(item.idNo)) {
					if (!isIdCardNoValid(item.idNo)) {
						idNoValid = false
						errIdNo = errIdNo + item.idNo + ' '
					}

					if (isAnZePower(this.product.id) && item.idNo.indexOf('51342') === 0) {
						rejectIdNo = rejectIdNo + item.idNo + ' '
					}

					if (map[item.idNo]) {
						idNoRepeat = true
						idNoRepeatData += `${item.idNo} `
					} else {
						map[item.idNo] = true
					}

					emps[empIdx] = {
						id: index,
						empName: item.name,
						empIdNo: item.idNo,
						empRole: '',
						dprice: item.premium,
						price: Math.round(item.premium * 100),
						inputName: 0,
						inputNo: 0,
						LAY_TABLE_INDEX: empIdx,
					}
					//身份校验
					checkIdNoData.push({
						name: item.name,
						idno: item.idNo,
					})
					if (!this.validatenull(item.profession)) {
						let professionCode = item.profession[2]
						let profession = this.getProfessionByCode(professionCode)
						//处理阳光运输
						// if (isXsmYunShu(this.product.type)) {
						//   if (this.validatenull(firstScope)) {
						//     firstScope = profession
						//   } else {
						//     if (yunshuSameScope === '' && firstScope.scope !== profession.scope) {
						//       yunshuSameScope = `【${firstScope.categoryName}】和【${profession.categoryName}】工种类型不一致，无法投保！`
						//     }
						//   }
						// }
						emps[empIdx].empRol = profession.scope
						emps[empIdx].professionCode = professionCode
						emps[empIdx].professionid = profession.id
					} else if (this.product.employee.showEmployeeProfession) {
						this.$alert('请先完成投保人员信息填写', '提示', {
							confirmButtonText: '确定',
						})
						return
					}
					empIdx = empIdx + 1
				}

				if (!this.validatenull(item.remark)) {
					item.remark = ''
				}
				//新增一个判断 如果钱为0，则需要重新算一次钱
				if (item.premium <= 0) {
					this.isNeedCalcPremium = true
				}
			}

			this.formSubmit.emps = emps

			if (!idNoValid) {
				this.$alert(`身份证号不正确: ${errIdNo}`, '提示', {
					confirmButtonText: '确定',
				})
			} else if (idNoRepeat) {
				this.$alert(`身份证号重复：${idNoRepeatData}`, '提示', {
					confirmButtonText: '确定',
				})
			} else if (yunshuSameScope) {
				this.$alert(yunshuSameScope, '提示', {
					confirmButtonText: '确定',
				})
			} else if (rejectIdNo !== '') {
				this.$alert(`四川省凉山彝族自治州人员无法投保该产品: ${rejectIdNo}`, '提示', {
					confirmButtonText: '确定',
				})
			} else if (emps.length === this.dataEmployee.length) {
				//身份证都填写，开始校验
				checkIdNo(checkIdNoData).then((resData) => {
					//处理校验数据
					let {data = [], code = -1} = resData.data
					if (code === 0) {
						let checkNoResult = ''
						for (let {name, idno, result} of data) {
							if (result === 1) {
								checkNoResult += `姓名：${name} 身份证：${idno}  ，`
							}
						}
						//韦锋账号不校验
						if (checkNoResult !== '' && this.userInfo.phone !== '18752004865') {
							this.$alert(`${checkNoResult} 校验不通过！`, '提示').then(() => {})
						} else {
							//成功
							this.onEmpCheckSuccess()
						}
					}
				})
			} else {
				this.$alert('请先完成投保人员信息填写', '提示', {
					confirmButtonText: '确定',
				})
			}
		},
		onEmpCheckSuccess() {
			this.formEmployee.isSubmitted = true
			this.optionEmployee.header = false
			this.dataEmployee.forEach((item, index) => {
				item.$cellEdit = false
			})
			//计算一次钱
			if (this.isNeedCalcPremium) {
				this.isNeedCalcPremium = false
				this.calcAllEmployeePremium()
			}

			// //安责险 结算钱，如果大于20万，则判断投保企业是否弹出身份证照片
			// if (this.product.type == 12) {
			//     if (this.totalPrice >= 200000 && !this.$refs.holder.isShowCardImg()) {
			//         this.$alert('由于保费大于20万，需要上传负责人身份证信息','警告',{
			//             type:'warning',
			//             confirmButtonText: '知道了'
			//         }).then(() => {
			//             //判断是否确定企业,展示身份证
			//
			//         })
			//     }
			// }
		},

		//
		//  发票
		//
		onInvoiceSubmitted(form) {
			Object.assign(this.formSubmit.invoice, form)

			this.formSubmit.invoiceType = form.type
			this.formSubmit.identification = form.identification

			this.formSubmit.isInvoiceSubmitted = true

			let invoice = this.$refs.invoice
			let invoiceView = this.$refs.invoiceView
			if (invoice != null && invoiceView != null) {
				let invoiceData = invoice.getData()
				if (invoiceData.invoiceType == 1) {
					Object.assign(invoiceData, {mailAreaName: form.mailAreaName})
				}
				invoiceView.setData(invoiceData)
			}
		},

		//  投保限制规则
		isInsureRestricted() {
			if (this.validatenull(this.product.restriction) || !this.product.restriction.enabled) {
				return false
			}

			let plan = this.$refs.plan
			let period = this.$refs.period

			if (plan == null && period == null) {
				return false
			}

			let rules = this.product.restriction.rules
			for (var ruleIdx = 0; ruleIdx < rules.length; ruleIdx++) {
				let rule = rules[ruleIdx]
				let conditionCount = 0
				let matchedCount = 0
				// if (!this.validatenull(rule.professionLevels)) {
				//     conditionCount = conditionCount + 1
				//     for (var i = 0; i < rule.professionLevels.length; i++) {
				//         let matched = false
				//         for (var j = 0; j < this.dataEmployee.length; j++) {
				//             if (this.dataEmployee[j].level == rule.professionLevels[i]) {
				//                 matched = true
				//                 matchedCount = matchedCount + 1
				//                 break
				//             }
				//         }
				//         if (matched) {
				//             break
				//         }
				//     }
				// }
				if (!this.validatenull(rule.professionCodes)) {
					conditionCount = conditionCount + 1
					for (var j = 0; j < this.dataEmployee.length; j++) {
						let profession = this.dataEmployee[j].profession
						if (!this.validatenull(profession) && rule.professionCodes.indexOf(profession[2]) >= 0) {
							matchedCount = matchedCount + 1
							break
						}
					}
				}
				if (!this.validatenull(rule.coverageList)) {
					conditionCount = conditionCount + 1
					if (plan != null) {
						let coverage = plan.getSubmitData().coverage
						for (var i = 0; i < rule.coverageList.length; i++) {
							if (coverage == rule.coverageList[i]) {
								matchedCount = matchedCount + 1
								break
							}
						}
					}
				}
				if (!this.validatenull(rule.termList)) {
					conditionCount = conditionCount + 1
					if (period != null) {
						let term = period.getSubmitData().term
						for (var i = 0; i < rule.termList.length; i++) {
							if (term == rule.termList[i]) {
								matchedCount = matchedCount + 1
								break
							}
						}
					}
				}

				if (matchedCount == conditionCount) {
					// this.$message({
					//     message: rule.message,
					//     type: 'warning'
					// });
					this.$alert(rule.message, '提示', {
						confirmButtonText: '我知道了',
					})
					return true
				}
			}

			return false
		},

		//  重新计算投保人员保费
		calcAllEmployeePremium() {
			if (!this.isEndorsement) {
				this.calcNewInsurePremium()
			} else {
				this.calcEndorsePremium()
			}
		},
		calcNewInsurePremium() {
			if (this.optionsProfession.length > 0 || !this.product.employee.showEmployeeProfession) {
				let holder = this.$refs.holder
				let insured = this.$refs.insured
				let plan = this.$refs.plan
				let period = this.$refs.period
				if (holder != null && plan != null && period != null) {
					//企业
					let {code, name, areaCode = '', certType = ''} = holder.getData()
					//方案
					let {
						coverage,
						feeRate,
						insureSuddenDeath,
						addMaim = '',
						costDuty = '',
						thirdDuty = '',
						allDuty = '',
						delayFee = '',
						medicalFee = '',
					} = plan.getSubmitData()
					//如果是安责1-5类，则必须要传值
					if (isAnZe15(this.product.type)) {
						if (addMaim === '' || allDuty === '' || delayFee === '' || medicalFee === '') {
							return
						}
					}
					if (isAnZe15(this.product.type) || isAnZeJianzhu(this.product.type)) {
						let tempIndex = this.dataEmployee.findIndex(({name = '', idNo = '', feeRate = ''}) => {
							return name === '' || idNo === '' || (feeRate === '' && isAnZe15(this.product.type))
						})
						if (tempIndex !== -1) {
							return
						}
					}
					//生效日期
					let {effectiveDate, term} = period.getSubmitData() || {}
					if (
						!this.validatenull(term) &&
						!this.validatenull(effectiveDate) &&
						!this.validatenull(coverage) &&
						!this.validatenull(code) &&
						(!this.validatenull(areaCode) || this.product.isInsureCar)
					) {
						let employeeInfo = {}
						employeeInfo.order = {
							productType: this.product.id,
							effectiveDate: effectiveDate,
							term: term,
						}
						//  鼎和需要选择是否投保猝死
						if (!this.validatenull(insureSuddenDeath)) {
							employeeInfo.order.insureSuddenDeath = insureSuddenDeath
						}
						//  国寿财 阳光运输 需要选择价格档次
						if (!this.validatenull(feeRate)) {
							employeeInfo.order.feeRate = feeRate
						}
						//前海
						if (!this.validatenull(addMaim)) {
							employeeInfo.order.addMaim = addMaim
						}
						//美亚
						if (!this.validatenull(costDuty)) {
							employeeInfo.order.costDuty = costDuty
						}
						//家电长期
						if (!this.validatenull(thirdDuty)) {
							employeeInfo.order.thirdDuty = thirdDuty
						}
						if (!this.validatenull(allDuty)) {
							employeeInfo.order.allDuty = allDuty
						}
						//delayFee = '', medicalFee = '' 按照上面写
						if (!this.validatenull(delayFee)) {
							employeeInfo.order.delayFee = delayFee
						}
						if (!this.validatenull(medicalFee)) {
							employeeInfo.order.medicalFee = medicalFee
						}
						employeeInfo.applicant = {
							unitCode: code,
							unitName: name,
						}
						if (!this.validatenull(areaCode)) {
							if (typeof areaCode === 'string') {
								employeeInfo.applicant.areaCode = areaCode
							} else {
								employeeInfo.applicant.areaCode = areaCode[2]
							}
						}
						//驾意险
						if (!this.validatenull(certType)) {
							employeeInfo.applicant.certType = certType
						}
						//投保和被保是否相同
						if (!this.formSubmit.sameUnit && insured != null) {
							//被保企业
							let {
								name: unitNameInsured = '',
								code: unitCodeInsured = '',
								areaCode: areaCodeInsured = '',
							} = insured.getData() || {}
							if (!this.validatenull(unitCodeInsured) && !this.validatenull(areaCodeInsured)) {
								employeeInfo.insurants = [
									{
										areaCode: typeof areaCodeInsured === 'string' ? areaCodeInsured : areaCodeInsured[2],
										unitCode: unitCodeInsured,
										unitName: unitNameInsured,
									},
								]
							}
						}
						//方案
						employeeInfo.insureAmount = coverage
						//驾意险
						employeeInfo.vehs = []
						//  投保人员信息
						employeeInfo.emps = []
						//如果是阳光驾意险，则不需要投保人员！！！！！！
						if (!this.product.isInsureCar) {
							let empIdx = 0
							this.dataEmployee.forEach((item, index) => {
								if (!this.validatenull(item.profession)) {
									let profession = this.getProfessionByCode(item.profession)
									if (!this.validatenull(profession)) {
										employeeInfo.emps[empIdx] = {
											professionId: profession.id,
											professionCode: profession.categoryCode,
											insureMoney: coverage,
										}
										if (isAnZe15(this.product.type)) {
											employeeInfo.emps[empIdx].feeRate = item.feeRate
										}
										//如果是安责1-5类，安责建筑，则传递是否涉高，身份证
										if (isAnZe15(this.product.type) || isAnZeJianzhu(this.product.type)) {
											employeeInfo.emps[empIdx].empName = item.name
											employeeInfo.emps[empIdx].empIdNo = item.idNo
										}
										empIdx = empIdx + 1
									}
								} else if (!this.product.employee.showEmployeeProfession) {
									employeeInfo.emps[empIdx] = {
										insureMoney: coverage,
									}
									//  平安电梯需要投保人员身份证
									if (!this.validatenull(item.idNo)) {
										employeeInfo.emps[empIdx].empIdNo = item.idNo
										empIdx = empIdx + 1
									}
								}
							})
						} else {
							if (this.formSubmit.vehs.length > 0) {
								employeeInfo.vehs = this.formSubmit.vehs
								employeeInfo.vehs[0].insureMoney = coverage
							}
						}
						if (employeeInfo.emps.length > 0 || employeeInfo.vehs.length > 0) {
							this.formEmployee.isLoading = true
							this.employeeLoading = true
							this.isCheckingInsure = true
							this.warningMessage = ''
							//  计算每个投保人员保费及总保费
							calcPremium(employeeInfo)
								.then((response = {}) => {
									let {
										msg = '计算保费失败，请稍后重试',
										data = {},
										code = -1,
										originCode = '',
										params = {},
									} = response.data || {}
									if (code !== 0 || this.validatenull(data)) {
										this.$alert(msg, '提示', {confirmButtonText: '我知道了'}).then(() => {})
										this.warningMessage = msg
										return
									}
									this.isNeedCalcPremium = false
									//结构数据
									let {
										productId = -1,
										emps = [],
										totalPrice,
										vehs = [],
										insureConfirmUrl = '',
										insureConfirmSample = '',
										apply = {},
									} = data
									//判断投保地区
									if (originCode === '205') {
										//重新提示，重新结算保费
										this.$confirm('营业执照地址为浙江、安徽、辽宁、重庆、河北地区的企业，请投保地区版。', '提示', {
											confirmButtonText: '确认投保地区版方案',
											cancelButtonText: '更改投保企业',
										})
											.then(() => {
												//替换productID,重新请求保费
												this.onChangeProductId(productId, true)
											})
											.catch(() => {
												//拒绝则需要修改投保企业，取消确定企业
												this.onInsureReadOver(false, true)
												holder.modifyUnit()
											})
									} else if (originCode === '210') {
										//从地区版本切换到全国，则重新计算保费
										//替换productID,重新请求保费
										this.onChangeProductId(productId, true)
									} else if (originCode === '200' || originCode === '0') {
										//替换productID,不需要重新结算保费
										this.onChangeProductId(productId, false)

										//总费用
										this.totalPrice = totalPrice
										let invoice = this.$refs.invoice
										if (invoice != null) {
											invoice.setData({money: this.totalPrice})
										}
										//阳光车意险单独处理
										if (this.product.isInsureCar) {
											if (vehs.length === 0) {
												this.$message.error('车意险数据有误！')
												return
											}
											//处理
											this.formSubmit.vehs[0].premium = vehs[0].premium
											this.$refs.carForm.setPremiumData(vehs[0])
										} else {
											//处理接口保费数据
											this.dataEmployee.forEach((itemData) => {
												let {idNo = '', profession = [], feeRate: feeRateWai = ''} = itemData
												//通过接口返回查找
												let tempData = emps.find(({empIdNo = '', professionCode = '', feeRate = ''}) => {
													if (empIdNo !== '') {
														return empIdNo.trim() === idNo.trim()
													} else if (professionCode !== '') {
														let isSameCode = professionCode === profession[2]
														return feeRate === '' ? isSameCode : isSameCode && feeRateWai == feeRate
													}
												})
												if (!this.validatenull(tempData)) {
													itemData.premium = tempData.premium
													itemData.priceId = tempData.priceId
												}
											})
										}
										if (!this.isEndorsement && holder) {
											//需要投保盖章文件
											this.$Bus.$emit('onBusFileConfirm', {insureConfirmUrl, insureConfirmSample, interType: 'entry'})
											// holder.onCalcNeedConfirmFile({
											//   insureConfirmUrl,
											//   insureConfirmSample,
											//   requiredInsureConfirm
											// })
										}
										//如果是家电24小时，则需要判断第三者
										if (isJiaDianLong(this.product.type)) {
											let {third = ''} = params
											this.$Bus.$emit('onThird', third || '0')
										}
										//控制生效日期！！！
										if (!this.validatenull(apply)) {
											let {strMaxEffective = '', strMinEffective = ''} = apply
											if (strMinEffective !== '' && strMaxEffective !== '') {
												this.$Bus.$emit('onBusEffectiveData', {
													minEffDate: strMinEffective,
													maxEffDate: strMaxEffective,
												})
											}
										}
									} else {
										//报错，暂时无定义，弹窗提示
										this.$alert(msg, '错误提示').then(() => {})
									}
								})
								.catch((error) => {
									let {message = ''} = error || {}
									this.isNeedCalcPremium = true
									if (!this.validatenull(message) && message !== '需要选择是否扩展伤残') {
										this.$alert(message, '提示', {
											confirmButtonText: '我知道了',
										}).then(() => {})
										if (message.includes('工种')) {
											//清除选择的雇员类别
											//清除工种
											this.dataEmployee.forEach((itemData) => {
												itemData.premium = 0
												itemData.priceId = 0
												itemData.profession = []
											})
											if (this.formEmployee.isSubmitted) {
												//按钮改为没点击
												this.handleEmployeeModify()
											}
											this.totalPrice = 0
										} else if (message.includes('起保') || message.includes('请求超时')) {
											if (this.formEmployee.isSubmitted) {
												//按钮改为没点击
												this.handleEmployeeModify()
											}
										}
									}
								})
								.finally(() => {
									this.formEmployee.isLoading = false
									this.employeeLoading = false
									this.isCheckingInsure = false
								})
						}
					}
				} else {
					this.dataEmployee.forEach((item, index) => {
						item.premium = 0
					})
				}
			}
		},
		//切换ID
		onChangeProductId(productId, isNeedCalc = false) {
			//替换productID
			if (productId !== -1 && this.product.id !== productId) {
				this.product.id = productId
				this.formSubmit.productId = productId
			}
			if (isNeedCalc) {
				//再次调用接口
				this.calcNewInsurePremium()
			}
		},
		getHistoryProfessionId(professionId, categoryCode) {
			if (this.validatenull(this.professionHistoryList) || this.professionHistoryList.length == 0) {
				return professionId
			}

			for (var i = 0; i < this.professionHistoryList.length; i++) {
				let profession = this.professionHistoryList[i]
				if (profession.categoryCode == categoryCode) {
					return profession.id
				}
			}

			return professionId
		},
		calcEndorsePremium() {
			let period = this.$refs.periodEndorse
			let plan = this.$refs.plan
			if (period != null && plan != null) {
				//如果是安责1-5类，则必须要传值
				if (isAnZeProduct(this.product.type)) {
					let tempIndex = this.dataEmployee.findIndex(({name = '', idNo = '', feeRate = ''}) => {
						return name === '' || idNo === '' || (isAnZe15(this.product.type) && feeRate === '')
					})
					if (tempIndex !== -1) {
						return
					}
				}

				let effectiveDate = period.getSubmitData().effectiveDate
				if (!this.validatenull(effectiveDate)) {
					var employeeInfo = {
						order: {
							parentId: this.orderId,
							effectiveDate: effectiveDate,
						},
						emps: [],
					}

					//  投保人员信息
					var empIdx = 0
					if (this.product.employee.showEmployeeProfession) {
						this.dataEmployee.forEach((item, index) => {
							if (this.product.type != 8 || (!this.validatenull(item.name) && !this.validatenull(item.idNo))) {
								if (!this.validatenull(item.profession)) {
									let profession = this.getProfessionByCode(item.profession)
									if (!this.validatenull(profession)) {
										employeeInfo.emps[empIdx] = {
											empName: item.name,
											empIdNo: item.idNo,
											empRole: profession.scope,
											// professionId: profession.id,
											professionId: this.getHistoryProfessionId(profession.id, profession.categoryCode),
											professionCode: profession.categoryCode,
											feeRate: item.feeRate || '',
										}
										empIdx = empIdx + 1
									}
								}
							}
						})
					} else {
						this.dataEmployee.forEach((item, index) => {
							//  平安电梯需要投保人员身份证
							if (!this.validatenull(item.idNo)) {
								employeeInfo.emps[empIdx] = {
									empName: item.name,
									empIdNo: item.idNo,
								}
								empIdx = empIdx + 1
							}
						})
					}

					if (employeeInfo.emps.length > 0) {
						this.formEmployee.isLoading = true
						this.employeeLoading = true

						this.isCheckingInsure = true
						//  计算每个投保人员保费及总保费
						calcPremium(employeeInfo)
							.then((response = {}) => {
								this.isNeedCalcPremium = false

								let {msg = '计算保费失败，请稍后重试', data = {}, code = -1} = response.data || {}
								if (code !== 0 || this.validatenull(data)) {
									this.$alert(msg, '提示', {confirmButtonText: '我知道了'}).then(() => {})
									this.warningMessage = msg
									return
								}
								let {emps = [], totalPrice, apply = {}} = data

								this.totalPrice = totalPrice
								//发票 填写信息tab
								let invoice = this.$refs.invoice
								if (invoice != null) {
									invoice.setData({money: this.totalPrice})
								}
								//发票 确认信息tab
								let invoiceView = this.$refs.invoiceView
								if (this.currentStep === '1' && invoiceView) {
									invoiceView.setData({money: this.totalPrice})
								}
								//处理接口保费数据
								this.dataEmployee.forEach((itemData) => {
									let {idNo = '', profession = [], feeRate: feeRateWai = ''} = itemData
									//通过接口返回查找
									let tempData = emps.find(({empIdNo = '', professionCode = '', feeRate = ''}) => {
										if (empIdNo !== '') {
											return empIdNo.trim() === idNo.trim()
										} else if (professionCode !== '') {
											let isSameCode = professionCode === profession[2]
											return feeRate === '' ? isSameCode : isSameCode && feeRateWai == feeRate
										}
									})
									if (!this.validatenull(tempData)) {
										itemData.premium = tempData.premium
										itemData.priceId = tempData.priceId
									}
								})

								//控制生效日期！！！
								if (!this.validatenull(apply)) {
									let {strMaxEffective = '', strMinEffective = ''} = apply
									if (strMinEffective !== '' && strMaxEffective !== '') {
										this.$Bus.$emit('onBusEffectiveData', {minEffDate: strMinEffective, maxEffDate: strMaxEffective})
									}
								}
							})
							.catch(({message = ''}) => {
								this.isNeedCalcPremium = true
								if (!this.validatenull(message)) {
									//清除选择的雇员类别
									this.$alert(message, '提示', {
										confirmButtonText: '我知道了',
									}).then(() => {})
									if (message.includes('工种')) {
										//清除工种
										this.dataEmployee.forEach((itemData) => {
											itemData.premium = 0
											itemData.priceId = 0
											itemData.profession = []
										})
									}
									//按钮改为没点击
									if (this.formEmployee.isSubmitted) {
										this.handleEmployeeModify()
									}
									this.totalPrice = 0
								}
							})
							.finally(() => {
								this.formEmployee.isLoading = false
								this.employeeLoading = false
								this.isCheckingInsure = false
							})
					}
				}
			} else {
				this.dataEmployee.forEach((item, index) => {
					item.premium = 0
				})
			}
		},

		//  Step2:  信息确认
		//  进入或返回确认保单步骤
		handleStepConfirm() {
			if (this.validatenull(this.warningMessage)) {
				this.currentStep = '1'
			} else {
				this.$confirm(this.warningMessage, '提示', {
					confirmButtonText: '确认投保',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						this.currentStep = '1'
						this.warningMessage = ''
					})
					.catch(() => {})
			}
		},

		//  Step3:  保单支付
		//  确认保单，进入支付步骤
		handleStepPay() {
			let checkInsureInfo = {}
			let jsonUnit = {}
			let jsonEmployees = {}
			let jsonOrder = {}
			let jsonVehicles = {}

			if (this.isEndorsement) {
				jsonUnit.id = this.orderDetails.holder.unitId
				jsonUnit.unit_code = this.orderDetails.holder.unitCode

				jsonEmployees.emp = []
				this.prepareEmployees(jsonEmployees.emp)

				jsonOrder = this.removeEmptyProps(this.formSubmit.getOrder())

				checkInsureInfo.orderId = this.orderId
				checkInsureInfo.pageId = this.pageId
				checkInsureInfo.act = 'add'

				checkInsureInfo.resultCode = this.resultCode
			} else {
				//处理盖章文件投保数据
				if (this.$refs.refFiles) {
					let fileUrl = this.$refs.refFiles.getFileUrl()
					if (fileUrl !== '') {
						this.formSubmit.toubao.InsureConfirm = fileUrl
					}
				}

				Object.assign(jsonUnit, this.formSubmit.toubao)
				jsonUnit.sameUnit = this.formSubmit.sameUnit

				let jsonInsured = {}
				if (!this.formSubmit.sameUnit) {
					Object.assign(jsonInsured, this.formSubmit.beibao)
				}
				//阳光车意险
				if (this.product.isInsureCar) {
					jsonVehicles.accident = 0
					jsonVehicles.coverage = this.formSubmit.coverage
					jsonVehicles.vehicle = this.$refs.carForm.getCheckInsureData()
				} else {
					jsonEmployees.accident = 0
					jsonEmployees.coverage = this.formSubmit.coverage
					jsonEmployees.emp = []
				}
				this.prepareEmployees(jsonEmployees.emp)

				jsonOrder = this.removeEmptyProps(this.formSubmit.getOrder())

				if (this.act === 'renew') {
					jsonOrder.issueFlag = this.orderId
					jsonOrder.shortTermPolicyNo = this.policyNo
					jsonOrder.updateTime = this.getUpdateTime(new Date())
				}

				let totalPrice = this.totalPrice
				let resultCode = this.resultCode

				checkInsureInfo.totalPrice = totalPrice
				checkInsureInfo.resultCode = resultCode

				checkInsureInfo.jsonInsured = this.formSubmit.sameUnit ? jsonInsured : JSON.stringify(jsonInsured)
			}

			checkInsureInfo.jsonUnit = JSON.stringify(jsonUnit)
			if (!this.validatenull(jsonEmployees)) {
				checkInsureInfo.jsonEmployees = JSON.stringify(jsonEmployees)
			}
			if (!this.validatenull(jsonVehicles)) {
				checkInsureInfo.jsonVehicles = JSON.stringify(jsonVehicles)
			}
			checkInsureInfo.jsonOrder = JSON.stringify(jsonOrder)
			//家电24小时短期,长期
			if (this.product.isShowInsuredList && this.$refs.unitInsured) {
				let tempInsuredData = this.$refs.unitInsured.onGetInsuredData()
				if (tempInsuredData.length > 0) {
					checkInsureInfo.jsonInsuredList = JSON.stringify(tempInsuredData)
				}
			}
			this.isCheckingInsure = true

			checkInsure(Object.assign(checkInsureInfo))
				.then((response) => {
					this.resultCode = response.data.originCode
					if (this.resultCode == 200) {
						//关闭2000限制啦！！！！！ 直接显示对公

						//调用接口获取主渠道数据
						if (this.product.type == '6' && this.totalPrice < 0) {
							return getChannelMainInfo()
						} else {
							this.isShowOfflinePayFan = true
							this.currentStep = '2'
						}
					} else {
						let errMsg = response.data.originMsg || ''
						this.$message({
							message: errMsg,
							type: this.resultCode == 405 ? 'warning' : 'error',
						})

						if (this.resultCode == 405) {
							this.$nextTick(() => {
								this.showRepeatEmpList()
							})
						} else if (this.resultCode == 500) {
							let data = response.data.data || []
							this.dataEmployee.forEach((item, index) => {
								for (var i = 0; i < data.length; i++) {
									if (data[i].empIdNo == item.idNo) {
										let itemNew = this.deepClone(item)
										itemNew.remark = '重复投保'
										this.dataEmployee.splice(index, 1, itemNew)
									}
								}
							})
							let repeatEmpsDlg = this.$refs.repeatEmpsDlg
							if (repeatEmpsDlg != null) {
								repeatEmpsDlg.setRepeatEmps(jsonOrder.effectiveDate, data)
							}
						} else if (this.resultCode == 501) {
							//501 驾意险，处理重复投保
							if (this.product.type === 14) {
								let data = response.data.data || []
								if (data.length > 0) {
									let repeatCarDlg = this.$refs.repeatCarDlg
									if (repeatCarDlg != null) {
										repeatCarDlg.setRepeatCar(data)
									}
								} else {
									this.$alert('该车辆信息已投保成功', '重复投保')
								}
							}
						}
					}
				})
				.then(
					({
						data: {
							data: {limitPublicPay = 'ON'},
						},
					}) => {
						//判断是否开启对公
						this.isShowOfflinePayFan = limitPublicPay !== 'ON'
						this.currentStep = '2'
					},
				)
				.catch(() => {})
				.finally(() => {
					this.isCheckingInsure = false
				})
		},
		handleRemoveRepeatEmps(repeatEmps) {
			let isRequestCalc = false
			for (let i = 0; i < repeatEmps.length; i++) {
				this.dataEmployee.forEach((item, index) => {
					if (repeatEmps[i].empIdNo === item.idNo) {
						isRequestCalc = true
						this.dataEmployee.splice(index, 1)
					}
				})
			}
			if (this.dataEmployee.length === 0) {
				this.totalPrice = 0
				let invoiceView = this.$refs.invoiceView
				if (invoiceView) {
					invoiceView.setData({money: this.totalPrice})
				}
			} else {
				if (isRequestCalc) {
					this.isCheckingInsure = true
				}
			}
		},
		//  显示非同一企业重复投保人员列表
		showRepeatEmpList() {
			let reqInfo = {
				pageNo: 1,
				pageSize: 10,
			}

			let jsonEmployees = {}
			let jsonOrder = {}

			jsonEmployees.accident = 0
			jsonEmployees.coverage = this.formSubmit.coverage
			jsonEmployees.emp = []

			this.prepareEmployees(jsonEmployees.emp)

			jsonOrder = this.removeEmptyProps(this.formSubmit.getOrder())

			jsonOrder.issueFlag = this.orderId
			jsonOrder.shortTermPolicyNo = this.policyNo

			jsonOrder.updateTime = this.getUpdateTime(new Date())

			reqInfo.jsonEmployees = JSON.stringify(jsonEmployees)
			reqInfo.jsonOrder = JSON.stringify(jsonOrder)

			this.isCheckingInsure = true
			getRepeatEmpList(Object.assign(reqInfo))
				.then((response) => {
					this.repeatEmpList.length = 0
					response.data.data.forEach((item, index) => {
						this.repeatEmpList.push(item)
					})

					this.repeatEmpListDialogVisible = true
				})
				.catch(() => {})
				.finally(() => {
					this.isCheckingInsure = false
				})
		},
		//  确认非同一企业再次投保，进入支付环节
		handleConfirmInsure() {
			this.repeatEmpListDialogVisible = false
			this.handleStepPay()
		},
		onPayOnline() {
			if (this.product.type === 13 && this.validatenull(this.myPayerInfo)) {
				//美亚
				this.$refs.payerInfo.showDialog()
			} else {
				//直接支付
				this.handlePayPolicy()
			}
		},
		//美亚支付人信息数据
		onPayerInfo(formData) {
			this.myPayerInfo = formData
			//处理支付
			this.handlePayPolicy()
		},
		//  在线支付
		handlePayPolicy() {
			this.paySource = 1
			if (this.isEndorsement) {
				this.payEndorse()
			} else {
				this.payInsure()
			}
		},
		//  批增支付
		async payEndorse() {
			let endorseInfo = {
				optType: this.paySource,
				orderId: this.orderId,
				effectiveDate: this.formSubmit.effectiveDate,
				premium: this.totalPrice,
			}
			let jsonEmps = {
				emp: [],
			}
			this.prepareEmployees(jsonEmps.emp)
			let jsonInvoice = {
				province: '',
				city: '',
				district: '',
			}
			let invoice = this.$refs.invoice
			if (invoice != null) {
				Object.assign(jsonInvoice, invoice.getSubmitData())
			}
			endorseInfo.jsonEmps = JSON.stringify(jsonEmps)
			endorseInfo.jsonInvoice = JSON.stringify(jsonInvoice)
			//处理美亚的支付人信息
			if (this.product.type === 13 && !this.validatenull(this.myPayerInfo)) {
				endorseInfo.jsonPayInfo = JSON.stringify(this.myPayerInfo)
			}
			//如果payOrderId不为空，则直接pay
			if (this.validatenull(this.payOrderId)) {
				try {
					this.isPay = true
					let {
						data: {data = {}, code = -1},
					} = (await endorseAdd(endorseInfo)) || {}
					if (code === 0) {
						this.payOrderId = data.payOrderId
						//处理支付
						await this.onDealPay()
					} else {
						this.isPay = false
					}
				} catch (e) {
					this.isPay = false
				}
			} else {
				//处理支付
				await this.onDealPay()
			}
		},
		//统一处理pay接口！！！，区分新增，和批增
		//this.isEndorsement
		async onDealPay() {
			let isOver = false
			this.isPay = true
			try {
				let {
					data: {originCode = '0', data = {}, code = -1, msg = '支付失败！请联系管理员'},
				} = (await pay(this.payOrderId)) || {}
				if (code === 0) {
					if (isAnZeProduct(this.product.type) && (originCode === '210' || originCode === '214')) {
						if (originCode === '214' || this.pollingCount >= 10) {
							//恢复  如果是安责险，5，6类需要人工核保
							isOver = true
							this.onAnzeHeBao(originCode)
						} else {
							this.pollingCount++
							setTimeout(() => {
								//再次调用支付
								this.onDealPay()
							}, 2000)
						}
					} else if (originCode === '200' || originCode === '0') {
						isOver = true
						if (this.isEndorsement) {
							//批增
							this.endorseOrderId = data.orderId
						} else {
							this.orderId = data.orderId
						}
						if (this.paySource === 1) {
							this.openPayWindow(this.payOrderId, data.payUrl)
						}
						this.currentStep = '3'
					} else {
						throw msg
					}
				}
			} catch (errorMsg) {
				this.isPay = false
				this.$alert(errorMsg, '提示')
					.then(() => {})
					.catch(() => {})
			} finally {
				if (isOver) {
					this.isPay = false
					this.$nextTick(() => {
						rrlog.capture(
							this.isEndorsement ? '批增' : '投保',
							{
								payOrderId: this.payOrderId,
							},
							{
								sign: false,
							},
						)
					})
				}
			}
		},

		//安责核保
		onAnzeHeBao(originCode = '') {
			let tempHint = originCode === '214' ? '含有5-6类工种，' : ''
			this.$alert(
				`您的保单${tempHint}需要保司在线核保确认后才可以进行支付等后续流程，可以在审核中保单、待支付保单中查询到相关保单`,
				'提示',
				{
					showClose: false,
					confirmButtonText: '知道了',
				},
			)
				.then(() => {
					this.$router.$avueRouter.closeTag()
					this.$router.push({
						path: this.$router.$avueRouter.getPath({
							src: '/insurance/policy/index',
						}),
						query: {
							status: 100,
						},
					})
				})
				.catch(() => {})
		},

		//处理泰康1-5类轮询支付
		onEndorsePay() {
			pay(this.payOrderId)
				.then((response) => {
					let {
						data: {originCode = '0', data = {}},
					} = response || {}
					if (isAnZe15(this.product.type) && originCode === '210') {
						setTimeout(() => {
							//再次调用支付
							this.onEndorsePay()
						}, 2000)
					} else {
						this.endorseOrderId = data.orderId
						if (this.paySource === 1) {
							this.openPayWindow(this.payOrderId, data.payUrl)
						}
						this.currentStep = '3'

						this.isPay = false
					}
				})
				.catch(() => {
					this.isPay = false
				})
		},
		//  普通投保支付
		async payInsure() {
			let jsonUnit = {
				sameUnit: this.formSubmit.sameUnit,
			}
			Object.assign(jsonUnit, this.formSubmit.toubao)
			let jsonInsured = {}
			if (!this.formSubmit.sameUnit) {
				Object.assign(jsonInsured, this.formSubmit.beibao)
			}
			let jsonVehicles = {}
			let jsonEmployees = {}
			//阳光车意险判断
			if (this.product.isInsureCar) {
				jsonVehicles = {
					accident: 0,
					coverage: this.formSubmit.coverage,
					vehicle: this.$refs.carForm.getCheckInsureData(),
				}
			} else {
				jsonEmployees = {
					accident: 0,
					coverage: this.formSubmit.coverage,
					emp: [],
				}
				this.prepareEmployees(jsonEmployees.emp)
			}
			let jsonOrder = {}
			jsonOrder = this.removeEmptyProps(this.formSubmit.getOrder())
			jsonOrder.paySource = this.paySource
			jsonOrder.ViewTime = this.getUpdateTime(new Date())

			let jsonInvoice = {}
			Object.assign(jsonInvoice, this.formSubmit.invoice)

			let insureInfo = {
				jsonUnit: JSON.stringify(jsonUnit),
				jsonInsured: this.formSubmit.sameUnit ? jsonInsured : JSON.stringify(jsonInsured),
				jsonOrder: JSON.stringify(jsonOrder),
				jsonInvoice: JSON.stringify(jsonInvoice),
				pageId: this.pageId,
			}
			if (!this.validatenull(jsonEmployees)) {
				insureInfo.jsonEmployees = JSON.stringify(jsonEmployees)
			}
			if (!this.validatenull(jsonVehicles)) {
				insureInfo.jsonVehicles = JSON.stringify(jsonVehicles)
			}
			//家电24小时短期，长期
			if (this.product.isShowInsuredList && this.$refs.unitInsured) {
				let tempInsuredData = this.$refs.unitInsured.onGetInsuredData()
				if (tempInsuredData.length > 0) {
					insureInfo.jsonInsuredList = JSON.stringify(tempInsuredData)
				}
			}
			//处理美亚的支付人信息
			if (this.product.type === 13 && !this.validatenull(this.myPayerInfo)) {
				insureInfo.jsonPayInfo = JSON.stringify(this.myPayerInfo)
			}
			//判断是否已经有payOrderId，如果有了，则直接调支付
			if (this.validatenull(this.payOrderId)) {
				try {
					this.isPay = true
					let {
						data: {data = {}, code = -1},
					} = (await insure(insureInfo)) || {}
					if (code === 0) {
						this.payOrderId = data.payOrderId
						//调用支付接口
						await this.onDealPay('new')
					} else {
						this.isPay = false
					}
				} catch (e) {
					this.isPay = false
				}
			} else {
				//支付
				await this.onDealPay('new')
			}
		},
		//封装新投保支付
		onNewPay() {
			pay(this.payOrderId)
				.then((response) => {
					let {
						data: {originCode = '0', data = {}},
					} = response || {}
					//安责1-5类
					if (isAnZe15(this.product.type) && originCode === '210') {
						setTimeout(() => {
							//再次调用支付
							this.onNewPay()
						}, 2000)
					} else if (isAnZeJianzhu(this.product.type) && originCode === '214') {
						//如果是安责险，5，6类需要人工核保
						this.$alert(
							'您的保单含有5-6类工种，需要保司在线核保确认后才可以进行支付等后续流程，可以在审核中保单、待支付保单中查询到相关保单',
							'提示',
							{
								showClose: false,
								confirmButtonText: '知道了',
							},
						)
							.then(() => {
								this.$router.$avueRouter.closeTag()
								this.$router.push({
									path: this.$router.$avueRouter.getPath({
										src: '/insurance/policy/index',
									}),
									query: {
										status: 100,
									},
								})
							})
							.catch(() => {})
					} else {
						this.orderId = data.orderId
						if (this.paySource == 1) {
							this.openPayWindow(this.payOrderId, data.payUrl)
						}
						this.currentStep = '3'
					}
				})
				.catch(() => {})
				.finally(() => {
					this.isPay = false
					this.$nextTick(() => {
						rrlog.capture(
							'投保',
							{
								payOrderId: this.payOrderId,
							},
							{
								sign: false,
							},
						)
					})
				})
		},

		//  对公支付
		async handlePayOffline() {
			this.paySource = 2
			let query = {
				pid: this.product.id,
			}
			if (this.orderId && this.act === 'add') {
				query.orderId = this.orderId
			}
			this.isPay = true
			try {
				let {
					data: {msg = '未知错误，请联系管理员', code = -1},
				} = (await canPayOffline(query)) || {}
				if (code === 0) {
					if (this.isEndorsement) {
						await this.payEndorse()
					} else {
						await this.payInsure()
					}
				} else {
					throw msg
				}
			} catch (error) {
				this.isPay = false
				this.$alert(error, '提示', {
					confirmButtonText: '确定',
				}).then(() => {})
			}
		},
		openPayWindow(payOrderId, payUrl) {
			//平安电梯由于http原因，调转新页面支付
			if (isPayToNewWindow(this.product.type)) {
				setStore({name: payOrderId, content: {url: payUrl}})
				this.$router.push({
					path: this.$router.$avueRouter.getPath({
						src: `/policy/pay/${payOrderId}`,
					}),
				})
			} else {
				this.$nextTick(() => {
					window.open(payUrl, '_blank')
				})
			}
		},

		//
		//  Step4:  支付完成
		//

		//  上次对公转账凭证相关
		submitTransferCertificate(form, done) {
			if (this.validatenull(this.imageTransferCertificate)) {
				this.$message({
					message: '请上传 转账凭证',
					type: 'warning',
				})
				done()
				return
			}

			let formData = new FormData()
			formData.append('file', this.fileTransferCertificate.raw)
			let query = {
				payTime: form.transferTime,
				orderId: !this.isEndorsement ? this.orderId : this.endorseOrderId,
			}
			let message = ''
			payOffline(query, formData)
				.then((response) => {
					this.$message({
						message: '转账凭证 提交成功',
						type: 'success',
					})
					this.$nextTick(() => {
						this.$router.$avueRouter.closeTag()
						this.$router.push({path: '/insurance/policy/index'})
					})
				})
				.catch((error) => {
					if (!this.validatenull(error)) {
						message = error.message || '未知错误'
					}
				})
				.finally(() => {
					done()
					if (!this.validatenull(message)) {
						this.$alert(message, '提示', {
							confirmButtonText: '确定',
						})
					}
				})
		},
		handleTransferCertificateSuccess(res, file) {
			this.imageTransferCertificate = URL.createObjectURL(file.raw)
		},
		beforeTransferCertificateUpload(file) {
			const isJPG = file.type === 'image/jpeg'
			const isPNG = file.type === 'image/png'
			const isLt2M = file.size / 1024 / 1024 < 5

			if (!isJPG && !isPNG) {
				this.$message.error('上传图片只支持JPG或PNG格式!')
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 5MB!')
			}
			return (isJPG || isPNG) && isLt2M
		},
		onTransferCertificateChange(file, fileList) {
			this.fileTransferCertificate = file
			var _this = this
			var event = event || window.event
			var file = event.target.files[0]
			var reader = new FileReader()
			//转base64
			reader.onload = function (e) {
				_this.imageTransferCertificate = e.target.result
			}
			reader.readAsDataURL(file)
		},

		//
		//  等待支付完成状态
		//
		//  查看保单
		handleViewPolicy() {
			this.$router.push({
				path: this.$router.$avueRouter.getPath({
					src: `/policy/details/${this.orderId}`,
				}),
			})
		},
		//  继续支付
		handlePayAgain() {
			this.isPay = true
			pay(this.payOrderId)
				.then((response) => {
					this.openPayWindow(this.payOrderId, response.data.data.payUrl)
					this.currentStep = '3'
				})
				.catch(() => {})
				.finally(() => {
					this.isPay = false
				})
		},

		//
		//  暂存保单
		//
		handleAddStaging() {
			this.isAddStaging = true

			if (!this.formSubmit.isHolderSubmitted) {
				this.stagingApplicant()
			}
			if (!this.formSubmit.isInsuredSubmitted && !this.formSubmit.sameUnit) {
				this.stagingInsured()
			}
			if (!this.formSubmit.isPlanSubmitted) {
				this.stagingPlan()
			}
			if (!this.formSubmit.isPeriodSubmitted) {
				this.stagingPeriod()
			}
			if (!this.formEmployee.isSubmitted) {
				this.stagingEmployee()
			}
			if (!this.formSubmit.isInvoiceSubmitted) {
				this.stagingInvoice()
			}
			if (!this.validatenull(this.stagingId)) {
				this.formSubmit.stagingid = this.stagingId
			}
			let tempRequest = this.deepClone(this.formSubmit)
			//险种
			tempRequest.insureType = this.product.type
			let {effectiveDate = '', expiryDate = ''} = tempRequest
			if (!this.validatenull(effectiveDate)) {
				tempRequest.effectiveDate = new Date(effectiveDate).getTime()
			}
			if (!this.validatenull(expiryDate)) {
				tempRequest.expiryDate = new Date(expiryDate).getTime()
			}
			addStaging(tempRequest)
				.then((response) => {
					this.stagingId = response.data.data
					this.$message({
						showClose: true,
						message: '保存成功',
						type: 'success',
					})
				})
				.catch(() => {})
				.finally(() => {
					this.isAddStaging = false
				})
		},
		stagingApplicant() {
			let holder = this.$refs.holder
			if (holder != null) {
				var submitData = holder.getSubmitData()
				Object.assign(this.formSubmit.toubao, submitData)

				if (this.formSubmit.sameUnit) {
					Object.assign(this.formSubmit.beibao, submitData)
				}
			}
		},
		stagingInsured() {
			let insured = this.$refs.insured
			if (insured != null) {
				let submitData = insured.getSubmitData()

				Object.assign(this.formSubmit.beibao, submitData)
			}
		},
		stagingPlan() {
			let plan = this.$refs.plan
			if (plan != null) {
				Object.assign(this.formSubmit, plan.getSubmitData())
			}
		},
		stagingPeriod() {
			let period = this.$refs.period

			if (period != null) {
				let data = period.getSubmitData()
				if (!this.validatenull(data)) {
					Object.assign(this.formSubmit, data)
					this.formSubmit.strEffectiveDate = !this.validatenull(data.effectiveDate)
						? data.effectiveDate + ' 00:00:00'
						: ''
					this.formSubmit.strExpiryDate = data.expiryDate
				}
			}
		},
		stagingEmployee() {
			var emps = []
			var empIdx = 0
			this.dataEmployee.forEach((item, index) => {
				if (!this.validatenull(item.name) && !this.validatenull(item.idNo)) {
					emps[empIdx] = {
						id: index,
						empName: item.name,
						empIdNo: item.idNo,
						dprice: item.premium,
						feeRate: item.feeRate,
						price: Math.round(item.premium * 100),
						inputName: 0,
						inputNo: 0,
						LAY_TABLE_INDEX: empIdx,
					}

					if (!this.validatenull(item.profession)) {
						let profession = this.getProfessionByCode(item.profession)
						emps[empIdx].empRol = profession.scope
						emps[empIdx].professionid = profession.id
						emps[empIdx].professionCode = profession.categoryCode
					}

					empIdx = empIdx + 1
				}
			})

			this.formSubmit.emps = emps
		},
		stagingInvoice() {
			let invoice = this.$refs.invoice

			if (invoice != null) {
				Object.assign(this.formSubmit.invoice, invoice.getSubmitData())
				this.formSubmit.invoiceType = invoice.getSubmitData().type
			}
		},

		//
		//  Utils
		//

		removeEmptyProps(obj) {
			var newObj = {}

			if (this.validatenull(obj)) {
				return newObj
			}

			for (var key in obj) {
				if (typeof obj[key] === 'Object') {
					newObj[key] = this.removeEmptyProps(obj[key])
				} else if (!this.validatenull(obj[key])) {
					newObj[key] = obj[key]
				}
			}

			return newObj
		},
		prepareEmployees(emps) {
			var empIdx = 0
			if (this.product.employee.showEmployeeProfession) {
				this.dataEmployee.forEach((item, index) => {
					if (!this.validatenull(item.profession)) {
						let profession = this.getProfessionByCode(item.profession)
						if (!this.validatenull(profession)) {
							emps[empIdx] = {
								empName: item.name,
								empIdNo: item.idNo,
								empRole: profession.scope,
								professionCode: profession.categoryCode,
								professionId: this.isEndorsement
									? this.getHistoryProfessionId(profession.id, profession.categoryCode)
									: profession.id,
								price: Math.round(item.premium * 100),
								priceId: item.priceId,
							}
							empIdx = empIdx + 1
						}
					}
				})
			} else {
				this.dataEmployee.forEach((item, index) => {
					emps[empIdx] = {
						empName: item.name,
						empIdNo: item.idNo,
						price: Math.round(item.premium * 100),
						priceId: item.priceId,
					}
					empIdx = empIdx + 1
				})
			}
		},
		filterCategoryByLevel(level) {
			let optionFiltered = this.deepClone(this.optionsProfessionAll)

			for (var idx1 = 0; idx1 < optionFiltered.length; idx1++) {
				var cat1 = optionFiltered[idx1]
				for (var idx2 = 0; idx2 < cat1.children.length; idx2++) {
					var cat2 = cat1.children[idx2]
					var idx3 = 0
					while (idx3 < cat2.children.length) {
						var cat3 = cat2.children[idx3]
						if (parseInt(cat3.professionLevel) > level) {
							cat2.children.splice(idx3, 1)
						} else {
							idx3 = idx3 + 1
						}
					}
				}
			}

			return optionFiltered
		},
		getProfessionName(profession) {
			if (!this.validatenull(profession) && profession.length >= 3) {
				let item = this.getProfessionByCode(profession)
				if (!this.validatenull(item)) {
					return item.categoryName
				}
			}
			return ''
		},
		getProfessionByCode(code) {
			let profession = {}
			let tempProfession = []
			if (code instanceof Array && code.length === 3) {
				tempProfession = code
			} else {
				tempProfession = this.convertProfessionCode(code)
			}
			let [category1, category2, category3] = tempProfession
			if (isXsmZhiZao(this.product.type) && category3.length === 6) {
				category1 = `0${category1}`
				category2 = `0${category2}`
			}
			let tempData = this.lastSaveProfessionData.find(({categoryCode}) => {
				return categoryCode === category3
			})
			if (!this.validatenull(tempData)) {
				return tempData
			}
			for (let idx1 = 0; idx1 < this.optionsProfession.length; idx1++) {
				let cat1 = this.optionsProfession[idx1]
				if (cat1.categoryCode === category1 || category1.includes(cat1.categoryCode)) {
					for (let idx2 = 0; idx2 < cat1.children.length; idx2++) {
						let cat2 = cat1.children[idx2]
						if (cat2.categoryCode === category2 || category2.includes(cat2.categoryCode)) {
							for (let idx3 = 0; idx3 < cat2.children.length; idx3++) {
								let cat3 = cat2.children[idx3]
								if (cat3.categoryCode === category3) {
									profession.id = cat3.id
									profession.categoryCode = cat3.categoryCode
									profession.categoryName = cat3.categoryName
									profession.scope = cat3.scope
									profession.professionLevel = cat3.professionLevel
									//保存
									this.lastSaveProfessionData.push(profession)
									return profession
								}
							}
						}
					}
				}
			}

			return profession
		},
		convertProfessionCode(professionCode = '') {
			//缓存处理
			let tempData = this.lastSaveProfessionCode.find((itemData) => {
				return itemData[2] === professionCode
			})
			if (!this.validatenull(tempData)) {
				return tempData
			}

			let profession = []
			let len0 = this.product.employee.professionLens[0]
			let len1 = this.product.employee.professionLens[1]
			//如果是建筑，制造业
			if (isXsmZhiZao(this.product.type) && professionCode.length === 6) {
				len0 = 1
				len1 = 3
			}
			if (!this.validatenull(professionCode)) {
				if (this.product.employee.professionFull) {
					let zero = '0'
					profession.push(professionCode.substr(0, len0) + zero.repeat(professionCode.length - len0))
					profession.push(professionCode.substr(0, len1) + zero.repeat(professionCode.length - len1))
				} else {
					profession.push(professionCode.substr(0, len0))
					profession.push(professionCode.substr(0, len1))
				}
				profession.push(professionCode)
			}
			this.lastSaveProfessionCode.push(profession)
			return profession
		},
		getUpdateTime(date) {
			let year = date.getFullYear()
			let month = date.getMonth()
			month = month + 1
			if (month < 10) {
				month = '0' + month
			}
			let day = date.getDate()
			if (day < 10) {
				day = '0' + day
			}
			let hour = date.getHours()
			if (hour < 10) {
				hour = '0' + hour
			}
			let minute = date.getMinutes()
			if (minute < 10) {
				minute = '0' + minute
			}
			let second = date.getSeconds()
			if (second < 10) {
				second = '0' + second
			}

			let updateTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second

			return updateTime
		},
		onGoToTop() {
			this.$nextTick(() => {
				cancelAnimationFrame(this.timer)
				const self = this
				self.timer = requestAnimationFrame(function fn() {
					let contentElement = document.getElementsByClassName('content_top')[0]
					let scrollTop = contentElement.scrollTop
					if (scrollTop > 300) {
						contentElement.scrollTop = scrollTop - 80
						self.timer = requestAnimationFrame(fn)
					} else {
						cancelAnimationFrame(self.timer)
					}
				})
			})
		},
		onInsureReadOver(isShow = false, isToTop = false) {
			this.isShowInsuredBtn = isShow
			this.$nextTick(() => {
				let content = document.getElementsByClassName('content_top')[0]
				if (content) {
					content.scrollTo({
						top: isToTop ? 0 : content.scrollHeight,
						behavior: 'smooth',
					})
				}
			})
		},
		onBackInsured() {
			this.$refs.custom_notice.onBackInsured()
		},
		onChangeInure() {
			//引流切换新市民
			if (this.$refs.refXsmYinLiu) {
				this.$refs.refXsmYinLiu.showXsmInsuresHint()
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
	display: table;
	content: '';
}

.clearfix:after {
	clear: both;
}

::v-deep .el-checkbox__label {
	display: inline-grid;
	white-space: pre-line;
	word-wrap: break-word;
	line-height: 20px;
}

::v-deep .el-checkbox__input {
	margin-top: 4px;
}

::v-deep .el-tabs__nav-scroll {
	height: 0;
	width: 0;
}

.content_top {
	overflow: scroll;
	height: 100%;
}
</style>
